// versione 17/04
import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

THREE.Cache.enabled = true;

// ========================================
// SHOPIFY INTEGRATION
// ========================================
const SHOPIFY = window.SHOPIFY_CONFIGURATOR || {};
const CONFIGURATOR_LOCALE = (document.documentElement.lang || '').toLowerCase().split('-')[0];
const isEnglishLocale = CONFIGURATOR_LOCALE === 'en';
const isGermanLocale = CONFIGURATOR_LOCALE === 'de';
const isFrenchLocale = CONFIGURATOR_LOCALE === 'fr';
const isSpanishLocale = CONFIGURATOR_LOCALE === 'es';

const CONFIGURATOR_TEXT = {
    it: {
        addToCart: 'Aggiungi al Carrello',
        addingToCart: 'Aggiunta in corso...',
        addedToCart: '✓ Aggiunto!',
        cartSuccess: '✓ Prodotto aggiunto al carrello',
        previewError: 'Errore nella generazione della preview del prodotto personalizzato',
        addError: 'Errore nell\'aggiunta al carrello',
        productVariantMissing: 'Errore: prodotto o variante non trovati',
        customProductCreateError: 'Errore creazione prodotto personalizzato',
        missingCustomVariant: 'La creazione del prodotto personalizzato non ha restituito una variante valida',
        cartAddGenericError: 'Errore aggiunta carrello',
        updateCustomization: 'Aggiorna personalizzazione',
        updatingInProgress: 'Aggiornamento in corso...',
        updatedDone: '✓ Aggiornato!',
        generatingPreview: 'Generazione anteprima...',
        creatingCustomProduct: 'Creazione prodotto personalizzato...',
        updatingCustomProduct: 'Aggiornamento prodotto personalizzato...',
        updatingCart: 'Aggiornamento carrello...',
        syncingShopify: 'Sincronizzazione con Shopify... ({attempt}/{max})',
        verifyCart: 'Verifica il carrello',
        cartVerifyMessage: 'Connessione interrotta: verifica il carrello prima di riprovare.',
        goToCart: 'Vai al carrello',
        continueConfiguring: 'Continua a configurare',
        cartReadError: 'Impossibile leggere il carrello',
        customProductMissingInCart: 'Il prodotto personalizzato non è più presente nel carrello',
        cartUpdateError: 'Errore aggiornamento carrello',
        customProductUpdateError: 'Errore aggiornamento prodotto personalizzato',
        previewGenerateError: 'Impossibile generare la preview del prodotto',
        previewUnsupported: 'Il browser non supporta la generazione della preview',
        cartOutcomeAmbiguous: 'Non è stato possibile verificare l’esito dell’aggiunta al carrello.',
        cartConnectionInterrupted: 'Connessione interrotta durante l’aggiunta al carrello. Riprova.',
        cartStatusDetail: 'Shopify Cart ({status}): {detail}',
        cartStatus: 'Shopify Cart ha risposto con stato {status}',
        configurationComplete: 'Configurazione Completata!',
        noLogo: 'NESSUN LOGO',
        noLogoAvailable: 'Nessun logo disponibile',
        customDesignKey: 'Design personalizzato',
        customDesignValue: 'Si'
    },
    en: {
        addToCart: 'Add to cart',
        addingToCart: 'Adding to cart...',
        addedToCart: '✓ Added!',
        cartSuccess: '✓ Product added to cart',
        previewError: 'Error generating the preview for the customized product',
        addError: 'Error adding to cart',
        productVariantMissing: 'Error: product or variant not found',
        customProductCreateError: 'Error creating custom product',
        missingCustomVariant: 'Custom product creation did not return a valid variant',
        cartAddGenericError: 'Error adding to cart',
        updateCustomization: 'Update customization',
        updatingInProgress: 'Updating...',
        updatedDone: '✓ Updated!',
        generatingPreview: 'Generating preview...',
        creatingCustomProduct: 'Creating custom product...',
        updatingCustomProduct: 'Updating custom product...',
        updatingCart: 'Updating cart...',
        syncingShopify: 'Syncing with Shopify... ({attempt}/{max})',
        verifyCart: 'Check your cart',
        cartVerifyMessage: 'Connection interrupted: check your cart before trying again.',
        goToCart: 'Go to cart',
        continueConfiguring: 'Keep configuring',
        cartReadError: 'Unable to read the cart',
        customProductMissingInCart: 'The custom product is no longer in the cart',
        cartUpdateError: 'Error updating the cart',
        customProductUpdateError: 'Error updating the custom product',
        previewGenerateError: 'Unable to generate the product preview',
        previewUnsupported: 'This browser does not support preview generation',
        cartOutcomeAmbiguous: 'We could not verify whether the item was added to the cart.',
        cartConnectionInterrupted: 'Connection interrupted while adding to the cart. Please try again.',
        cartStatusDetail: 'Shopify Cart ({status}): {detail}',
        cartStatus: 'Shopify Cart responded with status {status}',
        configurationComplete: 'Configuration complete!',
        noLogo: 'NO LOGO',
        noLogoAvailable: 'No logo available',
        customDesignKey: 'Design personalizzato',
        customDesignValue: 'Si'
    },
    de: {
        addToCart: 'In den Warenkorb',
        addingToCart: 'Wird in den Warenkorb gelegt...',
        addedToCart: '✓ Hinzugefügt!',
        cartSuccess: '✓ Produkt zum Warenkorb hinzugefügt',
        previewError: 'Fehler beim Erstellen der Vorschau für das personalisierte Produkt',
        addError: 'Fehler beim Hinzufügen zum Warenkorb',
        productVariantMissing: 'Fehler: Produkt oder Variante nicht gefunden',
        customProductCreateError: 'Fehler beim Erstellen des personalisierten Produkts',
        missingCustomVariant: 'Beim Erstellen des personalisierten Produkts wurde keine gültige Variante zurückgegeben',
        cartAddGenericError: 'Fehler beim Hinzufügen zum Warenkorb',
        updateCustomization: 'Personalisierung aktualisieren',
        updatingInProgress: 'Wird aktualisiert...',
        updatedDone: '✓ Aktualisiert!',
        generatingPreview: 'Vorschau wird erstellt...',
        creatingCustomProduct: 'Individuelles Produkt wird erstellt...',
        updatingCustomProduct: 'Individuelles Produkt wird aktualisiert...',
        updatingCart: 'Warenkorb wird aktualisiert...',
        syncingShopify: 'Synchronisierung mit Shopify... ({attempt}/{max})',
        verifyCart: 'Warenkorb prüfen',
        cartVerifyMessage: 'Verbindung unterbrochen: Prüfe den Warenkorb, bevor du es erneut versuchst.',
        goToCart: 'Zum Warenkorb',
        continueConfiguring: 'Weiter konfigurieren',
        cartReadError: 'Der Warenkorb konnte nicht gelesen werden',
        customProductMissingInCart: 'Das individuelle Produkt befindet sich nicht mehr im Warenkorb',
        cartUpdateError: 'Fehler beim Aktualisieren des Warenkorbs',
        customProductUpdateError: 'Fehler beim Aktualisieren des individuellen Produkts',
        previewGenerateError: 'Die Produktvorschau konnte nicht erstellt werden',
        previewUnsupported: 'Der Browser unterstützt die Vorschauerstellung nicht',
        cartOutcomeAmbiguous: 'Es konnte nicht überprüft werden, ob der Artikel zum Warenkorb hinzugefügt wurde.',
        cartConnectionInterrupted: 'Verbindung beim Hinzufügen zum Warenkorb unterbrochen. Bitte versuche es erneut.',
        cartStatusDetail: 'Shopify Cart ({status}): {detail}',
        cartStatus: 'Shopify Cart antwortete mit Status {status}',
        configurationComplete: 'Konfiguration abgeschlossen!',
        noLogo: 'KEIN LOGO',
        noLogoAvailable: 'Kein Logo verfügbar',
        customDesignKey: 'Personalisiertes Design',
        customDesignValue: 'Ja'
    },
    fr: {
        addToCart: 'Ajouter au panier',
        addingToCart: 'Ajout au panier...',
        addedToCart: '✓ Ajouté !',
        cartSuccess: '✓ Produit ajouté au panier',
        previewError: 'Erreur lors de la génération de l’aperçu du produit personnalisé',
        addError: 'Erreur lors de l’ajout au panier',
        productVariantMissing: 'Erreur : produit ou variante introuvable',
        customProductCreateError: 'Erreur lors de la création du produit personnalisé',
        missingCustomVariant: 'La création du produit personnalisé n’a pas renvoyé de variante valide',
        cartAddGenericError: 'Erreur lors de l’ajout au panier',
        updateCustomization: 'Mettre à jour la personnalisation',
        updatingInProgress: 'Mise à jour en cours...',
        updatedDone: '✓ Mis à jour !',
        generatingPreview: 'Génération de l’aperçu...',
        creatingCustomProduct: 'Création du produit personnalisé...',
        updatingCustomProduct: 'Mise à jour du produit personnalisé...',
        updatingCart: 'Mise à jour du panier...',
        syncingShopify: 'Synchronisation avec Shopify... ({attempt}/{max})',
        verifyCart: 'Vérifiez le panier',
        cartVerifyMessage: 'Connexion interrompue : vérifiez le panier avant de réessayer.',
        goToCart: 'Voir le panier',
        continueConfiguring: 'Continuer la configuration',
        cartReadError: 'Impossible de lire le panier',
        customProductMissingInCart: 'Le produit personnalisé n’est plus dans le panier',
        cartUpdateError: 'Erreur lors de la mise à jour du panier',
        customProductUpdateError: 'Erreur lors de la mise à jour du produit personnalisé',
        previewGenerateError: 'Impossible de générer l’aperçu du produit',
        previewUnsupported: 'Le navigateur ne prend pas en charge la génération de l’aperçu',
        cartOutcomeAmbiguous: 'Impossible de vérifier si l’article a été ajouté au panier.',
        cartConnectionInterrupted: 'Connexion interrompue pendant l’ajout au panier. Veuillez réessayer.',
        cartStatusDetail: 'Shopify Cart ({status}) : {detail}',
        cartStatus: 'Shopify Cart a répondu avec le statut {status}',
        configurationComplete: 'Configuration terminée !',
        noLogo: 'AUCUN LOGO',
        noLogoAvailable: 'Aucun logo disponible',
        customDesignKey: 'Design personnalisé',
        customDesignValue: 'Oui'
    },
    es: {
        addToCart: 'Añadir al carrito',
        addingToCart: 'Añadiendo al carrito...',
        addedToCart: '✓ Añadido',
        cartSuccess: '✓ Producto añadido al carrito',
        previewError: 'Error al generar la vista previa del producto personalizado',
        addError: 'Error al añadir al carrito',
        productVariantMissing: 'Error: producto o variante no encontrado',
        customProductCreateError: 'Error al crear el producto personalizado',
        missingCustomVariant: 'La creación del producto personalizado no ha devuelto una variante válida',
        cartAddGenericError: 'Error al añadir al carrito',
        updateCustomization: 'Actualizar personalización',
        updatingInProgress: 'Actualizando...',
        updatedDone: '✓ ¡Actualizado!',
        generatingPreview: 'Generando vista previa...',
        creatingCustomProduct: 'Creando producto personalizado...',
        updatingCustomProduct: 'Actualizando producto personalizado...',
        updatingCart: 'Actualizando carrito...',
        syncingShopify: 'Sincronizando con Shopify... ({attempt}/{max})',
        verifyCart: 'Revisa el carrito',
        cartVerifyMessage: 'Conexión interrumpida: revisa el carrito antes de volver a intentarlo.',
        goToCart: 'Ir al carrito',
        continueConfiguring: 'Seguir configurando',
        cartReadError: 'No se pudo leer el carrito',
        customProductMissingInCart: 'El producto personalizado ya no está en el carrito',
        cartUpdateError: 'Error al actualizar el carrito',
        customProductUpdateError: 'Error al actualizar el producto personalizado',
        previewGenerateError: 'No se pudo generar la vista previa del producto',
        previewUnsupported: 'El navegador no admite la generación de la vista previa',
        cartOutcomeAmbiguous: 'No se pudo verificar si el producto se añadió al carrito.',
        cartConnectionInterrupted: 'Conexión interrumpida al añadir al carrito. Inténtalo de nuevo.',
        cartStatusDetail: 'Shopify Cart ({status}): {detail}',
        cartStatus: 'Shopify Cart respondió con el estado {status}',
        configurationComplete: 'Configuración completada',
        noLogo: 'SIN LOGO',
        noLogoAvailable: 'No hay logotipos disponibles',
        customDesignKey: 'Diseño personalizado',
        customDesignValue: 'Sí'
    }
};

function configuratorText(key) {
    const localeText = CONFIGURATOR_TEXT[CONFIGURATOR_LOCALE] || CONFIGURATOR_TEXT.it;
    return localeText[key] || CONFIGURATOR_TEXT.it[key] || key;
}

function getCartLabels() {
    return {
        add: configuratorText('addToCart'),
        adding: configuratorText('addingToCart'),
        added: configuratorText('addedToCart'),
        previewError: configuratorText('previewError'),
        addError: configuratorText('addError')
    };
}

function localizeConfiguratorColorName(name) {
    if (!isEnglishLocale && !isGermanLocale && !isFrenchLocale && !isSpanishLocale) return name;
    const colorNamesEn = {
        'Nero': 'Black',
        'Grigio': 'Gray',
        'Bianco': 'White',
        'Rosa Fluo': 'Neon Pink',
        'Rosso': 'Red',
        'Arancione': 'Orange',
        'Giallo': 'Yellow',
        'Giallo Fluo': 'Neon Yellow',
        'Verde': 'Green',
        'Verde Fluo': 'Neon Green',
        'Azzurro': 'Light Blue',
        'Blu': 'Blue',
        'Viola': 'Purple'
    };
    const colorNamesDe = {
        'Nero': 'Schwarz',
        'Grigio': 'Grau',
        'Bianco': 'Weiß',
        'Rosa Fluo': 'Neonrosa',
        'Rosso': 'Rot',
        'Arancione': 'Orange',
        'Giallo': 'Gelb',
        'Giallo Fluo': 'Neongelb',
        'Verde': 'Grün',
        'Verde Fluo': 'Neongrün',
        'Azzurro': 'Hellblau',
        'Blu': 'Blau',
        'Viola': 'Violett'
    };
    const colorNamesFr = {
        'Nero': 'Noir',
        'Grigio': 'Gris',
        'Bianco': 'Blanc',
        'Rosa Fluo': 'Rose fluo',
        'Rosso': 'Rouge',
        'Arancione': 'Orange',
        'Giallo': 'Jaune',
        'Giallo Fluo': 'Jaune fluo',
        'Verde': 'Vert',
        'Verde Fluo': 'Vert fluo',
        'Azzurro': 'Bleu clair',
        'Blu': 'Bleu',
        'Viola': 'Violet'
    };
    const colorNamesEs = {
        'Nero': 'Negro',
        'Grigio': 'Gris',
        'Bianco': 'Blanco',
        'Rosa Fluo': 'Rosa flúor',
        'Rosso': 'Rojo',
        'Arancione': 'Naranja',
        'Giallo': 'Amarillo',
        'Giallo Fluo': 'Amarillo flúor',
        'Verde': 'Verde',
        'Verde Fluo': 'Verde flúor',
        'Azzurro': 'Azul claro',
        'Blu': 'Azul',
        'Viola': 'Morado'
    };
    if (isEnglishLocale) return colorNamesEn[name] || name;
    if (isGermanLocale) return colorNamesDe[name] || name;
    if (isFrenchLocale) return colorNamesFr[name] || name;
    if (isSpanishLocale) return colorNamesEs[name] || name;
    return name;
}

function localizeConfiguratorStepName(name) {
    if (!isEnglishLocale && !isGermanLocale && !isFrenchLocale && !isSpanishLocale) return name;
    const stepNamesEn = {
        'Tipo Base': 'Base Type',
        'Colore Base': 'Base Color',
        'Logo': 'Logo',
        'Colore Logo': 'Logo Color',
        'Logo Secondario': 'Secondary Logo',
        'Colore Logo Secondario': 'Secondary Logo Color',
        'Fori': 'Holes',
        'Colore Fori': 'Hole Color',
        'Colore Parte Inferiore': 'Bottom Part Color'
    };
    const stepNamesDe = {
        'Tipo Base': 'Basistyp',
        'Colore Base': 'Grundfarbe',
        'Logo': 'Logo',
        'Colore Logo': 'Logofarbe',
        'Logo Secondario': 'Sekundäres Logo',
        'Colore Logo Secondario': 'Farbe des Sekundärlogos',
        'Fori': 'Bohrungen',
        'Colore Fori': 'Farbe der Bohrungen',
        'Colore Parte Inferiore': 'Farbe Unterteil'
    };
    const stepNamesFr = {
        'Tipo Base': 'Type de base',
        'Colore Base': 'Couleur de base',
        'Logo': 'Logo',
        'Colore Logo': 'Couleur du logo',
        'Logo Secondario': 'Logo secondaire',
        'Colore Logo Secondario': 'Couleur du logo secondaire',
        'Fori': 'Trous',
        'Colore Fori': 'Couleur des trous',
        'Colore Parte Inferiore': 'Couleur de la partie inférieure'
    };
    const stepNamesEs = {
        'Tipo Base': 'Tipo de base',
        'Colore Base': 'Color de base',
        'Logo': 'Logo',
        'Colore Logo': 'Color del logo',
        'Logo Secondario': 'Logo secundario',
        'Colore Logo Secondario': 'Color del logo secundario',
        'Fori': 'Agujeros',
        'Colore Fori': 'Color de los agujeros',
        'Colore Parte Inferiore': 'Color de la parte inferior'
    };
    if (isEnglishLocale && stepNamesEn[name]) return stepNamesEn[name];
    if (isGermanLocale && stepNamesDe[name]) return stepNamesDe[name];
    if (isFrenchLocale && stepNamesFr[name]) return stepNamesFr[name];
    if (isSpanishLocale && stepNamesEs[name]) return stepNamesEs[name];
    if (name.startsWith('Colore ')) {
        const suffix = name.replace('Colore ', '');
        if (isEnglishLocale) return 'Color ' + suffix;
        if (isGermanLocale) return 'Farbe ' + suffix;
        if (isFrenchLocale) return 'Couleur ' + suffix;
        if (isSpanishLocale) return 'Color ' + suffix;
    }
    return name;
}
const MODEL_URL = SHOPIFY.config?.model_url;
const INITIAL_ROTATION_RAW = (SHOPIFY.config && Object.prototype.hasOwnProperty.call(SHOPIFY.config, 'initialRotation'))
  ? SHOPIFY.config.initialRotation
  : null;
const INITIAL_ROTATION = (INITIAL_ROTATION_RAW && typeof INITIAL_ROTATION_RAW === 'object')
  ? {
      x: Number.isFinite(INITIAL_ROTATION_RAW.x) ? INITIAL_ROTATION_RAW.x : 0,
      y: Number.isFinite(INITIAL_ROTATION_RAW.y) ? INITIAL_ROTATION_RAW.y : 0,
      z: Number.isFinite(INITIAL_ROTATION_RAW.z) ? INITIAL_ROTATION_RAW.z : 0
    }
  : null;
const SCREEN_VIEW_RAW = SHOPIFY.config?.screen_view ?? SHOPIFY.config?.screenView ?? null;
const STEP_ROTATIONS_RAW = SHOPIFY.config?.step_rotations ?? SHOPIFY.config?.stepRotations ?? {};
const STEP_ROTATION_DEFAULT_DURATION = Number.isFinite(SHOPIFY.config?.step_rotation_duration_ms)
  ? SHOPIFY.config.step_rotation_duration_ms
  : (Number.isFinite(SHOPIFY.config?.stepRotationDurationMs) ? SHOPIFY.config.stepRotationDurationMs : 700);
const THREE_CDN_BASE = 'https://unpkg.com/three@0.162.0/';
const DRACO_DECODER_PATH = `${THREE_CDN_BASE}examples/jsm/libs/draco/`;
const WORLD_UP = new THREE.Vector3(0, 1, 0);
let baseRotationEuler = null;

// ========================================
// UTILITY FUNCTIONS
// ========================================
function normalizeStepKey(value) {
  if (typeof value !== 'string') return '';
  return value.trim().toLowerCase();
}

function normalizeStepRotations(raw) {
  const map = {};
  if (!raw) return map;

  if (Array.isArray(raw)) {
    raw.forEach((entry) => {
      if (!entry || typeof entry !== 'object') return;
      const stepIndex = Number.parseInt(entry.step ?? entry.stepIndex ?? entry.index, 10);
      if (Number.isFinite(stepIndex)) {
        map[stepIndex] = entry;
        return;
      }
      const stepName = entry.step_name ?? entry.stepName ?? entry.name;
      const normalizedName = normalizeStepKey(stepName);
      if (normalizedName) {
        map[normalizedName] = entry;
      }
    });
    return map;
  }

  if (typeof raw === 'object') {
    Object.entries(raw).forEach(([key, value]) => {
      const stepIndex = Number.parseInt(key, 10);
      if (Number.isFinite(stepIndex)) {
        map[stepIndex] = value;
        return;
      }
      const normalizedKey = normalizeStepKey(key);
      if (normalizedKey) {
        map[normalizedKey] = value;
      }
    });
  }

  return map;
}

const STEP_ROTATIONS = normalizeStepRotations(STEP_ROTATIONS_RAW);

function normalizeViewAxis(view) {
  if (!view || typeof view !== 'string') return null;
  const cleaned = view.trim().toLowerCase();
  if (cleaned === 'top') return 'z';
  if (cleaned === 'bottom') return '-z';
  if (cleaned === '+x' || cleaned === 'x') return 'x';
  if (cleaned === '-x') return '-x';
  if (cleaned === '+y' || cleaned === 'y') return 'y';
  if (cleaned === '-y') return '-y';
  if (cleaned === '+z' || cleaned === 'z') return 'z';
  if (cleaned === '-z') return '-z';
  return null;
}

function axisVectorFromView(axis) {
  switch (axis) {
    case 'x':
      return new THREE.Vector3(1, 0, 0);
    case '-x':
      return new THREE.Vector3(-1, 0, 0);
    case 'y':
      return new THREE.Vector3(0, 1, 0);
    case '-y':
      return new THREE.Vector3(0, -1, 0);
    case 'z':
      return new THREE.Vector3(0, 0, 1);
    case '-z':
      return new THREE.Vector3(0, 0, -1);
    default:
      return null;
  }
}

function resolveViewRotation(view) {
  const axis = normalizeViewAxis(view);
  if (!axis) return null;

  const baseEuler = baseRotationEuler ?? (rotationRoot ? rotationRoot.rotation : (miscelatoreModel ? miscelatoreModel.rotation : null));
  if (!baseEuler) return null;

  const axisVector = axisVectorFromView(axis);
  if (!axisVector) return null;

  const baseQuat = new THREE.Quaternion().setFromEuler(baseEuler);
  const axisWorld = axisVector.clone().applyQuaternion(baseQuat).normalize();
  const alignQuat = new THREE.Quaternion().setFromUnitVectors(axisWorld, WORLD_UP);
  const targetQuat = alignQuat.multiply(baseQuat);

  return new THREE.Euler().setFromQuaternion(targetQuat, 'XYZ');
}

function parseAngleToRadians(value, unit = '') {
  const number = typeof value === 'number' ? value : Number.parseFloat(value);
  if (!Number.isFinite(number)) return null;

  const normalizedUnit = typeof unit === 'string' ? unit.trim().toLowerCase() : '';
  if (
    normalizedUnit === 'deg'
    || normalizedUnit === 'degree'
    || normalizedUnit === 'degrees'
    || normalizedUnit === 'desgree'
    || normalizedUnit === 'desgrees'
  ) {
    return THREE.MathUtils.degToRad(number);
  }

  return number;
}

function getBaseScreenshotRotation() {
  return (baseRotationEuler || new THREE.Euler(0, 0, 0, 'XYZ')).clone();
}

function applyScreenViewOffset(euler, axis, radians) {
  if (!euler || !axis || !Number.isFinite(radians)) return euler;
  if (axis === 'x') euler.x += radians;
  if (axis === 'y') euler.y += radians;
  if (axis === 'z') euler.z += radians;
  return euler;
}

function parseScreenViewOffsetString(value) {
  if (typeof value !== 'string') return null;

  const cleaned = value.trim().toLowerCase().replace(/,/g, ' ');
  if (!cleaned) return null;

  const axisOnly = normalizeViewAxis(cleaned);
  if (axisOnly) {
    return {
      rotation: resolveViewRotation(axisOnly)
    };
  }

  const match = cleaned.match(/^[+]?([xyz])\s*[:=]?\s*([+-]?\d+(?:\.\d+)?)\s*(degrees|degree|deg|desgrees|desgree|radians|radian|rad)?$/);
  if (!match) return null;

  return {
    axis: match[1],
    radians: parseAngleToRadians(match[2], match[3] || 'degrees')
  };
}

function applyScreenViewObjectOffsets(euler, raw) {
  const unit = raw.unit ?? 'degrees';
  ['x', 'y', 'z'].forEach((axis) => {
    if (raw[axis] !== undefined && Number.isFinite(Number(raw[axis]))) {
      applyScreenViewOffset(euler, axis, parseAngleToRadians(raw[axis], unit));
    }
  });
  return euler;
}

function resolveScreenViewRotation() {
  const screenshotRotation = getBaseScreenshotRotation();
  if (!SCREEN_VIEW_RAW) return screenshotRotation;

  if (typeof SCREEN_VIEW_RAW === 'string') {
    const offset = parseScreenViewOffsetString(SCREEN_VIEW_RAW);
    if (!offset) return screenshotRotation;
    if (offset.rotation) return offset.rotation;
    return applyScreenViewOffset(screenshotRotation, offset.axis, offset.radians);
  }

  if (typeof SCREEN_VIEW_RAW === 'object') {
    const axis = SCREEN_VIEW_RAW.axis ?? SCREEN_VIEW_RAW.view;
    const viewAxis = typeof axis === 'string' ? normalizeViewAxis(axis) : null;
    const degrees = SCREEN_VIEW_RAW.degrees ?? SCREEN_VIEW_RAW.angleDegrees;
    const angle = degrees ?? SCREEN_VIEW_RAW.angle ?? SCREEN_VIEW_RAW.rotation;
    if (viewAxis && angle === undefined) {
      return resolveViewRotation(viewAxis) || screenshotRotation;
    }
    if (typeof axis === 'string' && ['x', 'y', 'z'].includes(axis.trim().toLowerCase())) {
      const degrees = SCREEN_VIEW_RAW.degrees ?? SCREEN_VIEW_RAW.angleDegrees;
      const angle = degrees ?? SCREEN_VIEW_RAW.angle ?? SCREEN_VIEW_RAW.rotation;
      const unit = degrees !== undefined ? 'degrees' : (SCREEN_VIEW_RAW.unit ?? 'degrees');
      return applyScreenViewOffset(screenshotRotation, axis.trim().toLowerCase(), parseAngleToRadians(angle, unit) ?? 0);
    }

    return applyScreenViewObjectOffsets(screenshotRotation, SCREEN_VIEW_RAW);
  }

  return screenshotRotation;
}

function normalizeAngle(angle) {
  let normalized = angle;
  while (normalized > Math.PI) normalized -= 2 * Math.PI;
  while (normalized < -Math.PI) normalized += 2 * Math.PI;
  return normalized;
}

function shortestAngleDiff(from, to) {
  return normalizeAngle(to - from);
}

let rotationAnimationId = null;
let viewResetAnimationId = null;
const viewResetCache = {
  startTarget: new THREE.Vector3(),
  endTarget: new THREE.Vector3(),
  currentTarget: new THREE.Vector3(),
  startOffset: new THREE.Vector3(),
  endOffset: new THREE.Vector3(),
  currentOffset: new THREE.Vector3(),
  endPosition: new THREE.Vector3(),
  startSpherical: new THREE.Spherical(),
  endSpherical: new THREE.Spherical(),
  currentSpherical: new THREE.Spherical()
};

function getDefaultStepRotation() {
  if (baseRotationEuler) return baseRotationEuler.clone();
  const topRotation = resolveViewRotation('z');
  return topRotation ?? new THREE.Euler(0, 0, 0, 'XYZ');
}

function resolveStepRotationStringTarget(value) {
  const viewRotation = resolveViewRotation(value);
  if (viewRotation) return viewRotation;

  const offset = parseScreenViewOffsetString(value);
  if (!offset) return null;
  if (Object.prototype.hasOwnProperty.call(offset, 'rotation')) return offset.rotation;
  return applyScreenViewOffset(getBaseScreenshotRotation(), offset.axis, offset.radians);
}

function resolveRotationTarget(entry) {
  if (!entry) return null;
  if (typeof entry === 'string') {
    return resolveStepRotationStringTarget(entry);
  }
  if (entry.rotation && typeof entry.rotation === 'object') {
    const rotation = entry.rotation;
    return new THREE.Euler(
      Number.isFinite(rotation.x) ? rotation.x : 0,
      Number.isFinite(rotation.y) ? rotation.y : 0,
      Number.isFinite(rotation.z) ? rotation.z : 0,
      'XYZ'
    );
  }
  if (Number.isFinite(entry.x) || Number.isFinite(entry.y) || Number.isFinite(entry.z)) {
    return new THREE.Euler(
      Number.isFinite(entry.x) ? entry.x : 0,
      Number.isFinite(entry.y) ? entry.y : 0,
      Number.isFinite(entry.z) ? entry.z : 0,
      'XYZ'
    );
  }
  if (typeof entry.view === 'string') {
    return resolveStepRotationStringTarget(entry.view);
  }
  return null;
}

function getStepIndexByName(stepName) {
  const normalizedName = normalizeStepKey(stepName);
  if (!normalizedName) return null;
  const index = configSteps.findIndex((step) => (
    normalizeStepKey(step.name) === normalizedName
    || normalizeStepKey(step.id) === normalizedName
  ));
  return index >= 0 ? index + 1 : null;
}

function resolveRotationEntryForStep(stepIndex) {
  if (!Number.isFinite(stepIndex)) return { key: null, entry: null };
  let best = null;
  Object.entries(STEP_ROTATIONS).forEach(([key, entry]) => {
    let anchorIndex = Number.parseInt(key, 10);
    if (!Number.isFinite(anchorIndex)) {
      anchorIndex = getStepIndexByName(key);
    }
    if (!Number.isFinite(anchorIndex) || anchorIndex > stepIndex) return;
    if (!best || anchorIndex > best.anchorIndex) {
      best = { key, entry, anchorIndex };
    }
  });
  return best ? { key: best.key, entry: best.entry } : { key: null, entry: null };
}

function animateModelRotation(targetEuler, durationMs = STEP_ROTATION_DEFAULT_DURATION) {
  const rotationTarget = rotationRoot ?? miscelatoreModel;
  if (!rotationTarget || !isModelLoaded || !targetEuler) return;
  if (!Number.isFinite(durationMs) || durationMs <= 0) {
    rotationTarget.rotation.copy(targetEuler);
    requestRender();
    return;
  }

  if (rotationAnimationId) cancelAnimationFrame(rotationAnimationId);

  const startEuler = rotationTarget.rotation.clone();
  const delta = {
    x: shortestAngleDiff(startEuler.x, targetEuler.x),
    y: shortestAngleDiff(startEuler.y, targetEuler.y),
    z: shortestAngleDiff(startEuler.z, targetEuler.z)
  };
  const startTime = performance.now();

  const tick = (now) => {
    const t = Math.min(1, (now - startTime) / durationMs);
    const eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    rotationTarget.rotation.set(
      startEuler.x + delta.x * eased,
      startEuler.y + delta.y * eased,
      startEuler.z + delta.z * eased
    );
    requestRender();
    if (t < 1) {
      rotationAnimationId = requestAnimationFrame(tick);
    }
  };

  rotationAnimationId = requestAnimationFrame(tick);
}

function animateViewReset(durationMs = STEP_ROTATION_DEFAULT_DURATION) {
  if (!isModelLoaded || !controls || !hasSavedViewState) return;

  const camera = controls.object;
  const cache = viewResetCache;
  cache.startTarget.copy(controls.target);
  const startZoom = camera.zoom;

  if (controls.target0) {
    cache.endTarget.copy(controls.target0);
  } else {
    cache.endTarget.copy(cache.startTarget);
  }
  const endZoom = Number.isFinite(controls.zoom0) ? controls.zoom0 : startZoom;
  const hasZoom = Number.isFinite(endZoom) && Math.abs(endZoom - startZoom) > 1e-6;
  if (controls.position0) {
    cache.endPosition.copy(controls.position0);
  } else {
    cache.endPosition.copy(camera.position);
  }

  cache.startOffset.copy(camera.position).sub(cache.startTarget);
  cache.endOffset.copy(cache.endPosition).sub(cache.endTarget);
  cache.startSpherical.setFromVector3(cache.startOffset);
  cache.endSpherical.setFromVector3(cache.endOffset);
  const deltaTheta = shortestAngleDiff(cache.startSpherical.theta, cache.endSpherical.theta);
  const deltaPhi = cache.endSpherical.phi - cache.startSpherical.phi;
  const deltaRadius = cache.endSpherical.radius - cache.startSpherical.radius;

  if (!Number.isFinite(durationMs) || durationMs <= 0) {
    controls.target.copy(cache.endTarget);
    camera.position.copy(cache.endPosition);
    if (hasZoom) {
      camera.zoom = endZoom;
      camera.updateProjectionMatrix();
    }
    controls.update();
    requestRender();
    return;
  }

  if (viewResetAnimationId) cancelAnimationFrame(viewResetAnimationId);

  const startTime = performance.now();
  const tick = (now) => {
    const t = Math.min(1, (now - startTime) / durationMs);
    const eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

    cache.currentTarget.lerpVectors(cache.startTarget, cache.endTarget, eased);
    const currentRadius = cache.startSpherical.radius + deltaRadius * eased;
    const currentTheta = cache.startSpherical.theta + deltaTheta * eased;
    const rawPhi = cache.startSpherical.phi + deltaPhi * eased;
    const currentPhi = Math.min(Math.PI - 1e-6, Math.max(1e-6, rawPhi));
    cache.currentSpherical.set(currentRadius, currentPhi, currentTheta);
    cache.currentOffset.setFromSpherical(cache.currentSpherical);

    controls.target.copy(cache.currentTarget);
    camera.position.copy(cache.currentTarget).add(cache.currentOffset);
    if (hasZoom) {
      camera.zoom = startZoom + (endZoom - startZoom) * eased;
      camera.updateProjectionMatrix();
    }

    controls.update();
    requestRender();
    if (t < 1) {
      viewResetAnimationId = requestAnimationFrame(tick);
    }
  };

  viewResetAnimationId = requestAnimationFrame(tick);
}

function applyStepRotation(stepIndex) {
  if (!Number.isFinite(stepIndex)) return;
  const { key, entry } = resolveRotationEntryForStep(stepIndex);
  if (key === lastAppliedRotationKey) return;

  const targetRotation = entry ? resolveRotationTarget(entry) : getDefaultStepRotation();
  if (!targetRotation) return;
  const durationMs = entry && Number.isFinite(entry.duration) ? entry.duration : STEP_ROTATION_DEFAULT_DURATION;
  animateModelRotation(targetRotation, durationMs);
  lastAppliedRotationKey = key;
}

function formatLogoName(name) {
    return name
        .replace(/^[Cc]ulo[_\s]+/i, '')
        .replace(/^[Ll]ogo2[_\s]+/i, '')
        .replace(/^[Ll]ogo[_\s]+/i, '')
        .replace(/_/g, ' ')
        .replace(/\s*v\d+$/i, '')
        .replace(/\s*\(\d+\)$/i, '')
        .replace(/\d+$/, '')
        .trim()
        .toUpperCase();
}

function splitPillLabel(label) {
    const text = String(label || '').trim().replace(/\s+/g, ' ');
    const words = text.split(/\s+/);
    if (words.length < 2) return [text];

    let splitIndex = 1;
    let smallestDifference = Infinity;
    let firstLineLength = 0;

    for (let index = 1; index < words.length; index += 1) {
        firstLineLength += words[index - 1].length + (index > 1 ? 1 : 0);
        const secondLineLength = text.length - firstLineLength - 1;
        const difference = Math.abs(firstLineLength - secondLineLength);
        if (difference < smallestDifference) {
            smallestDifference = difference;
            splitIndex = index;
        }
    }

    return [words.slice(0, splitIndex).join(' '), words.slice(splitIndex).join(' ')];
}

// Memoizzazione per collectMaterials
const materialCache = new WeakMap();
function getUniqueMaterials(mesh) {
    if (!mesh || !mesh.material) return [];

    if (!mesh.userData.configuratorMaterialCloned) {
        mesh.material = Array.isArray(mesh.material)
            ? mesh.material.map((material) => material.clone())
            : mesh.material.clone();
        mesh.userData.configuratorMaterialCloned = true;
    }

    return Array.isArray(mesh.material) ? mesh.material : [mesh.material];
}

function collectMaterials(mesh) {
    if (materialCache.has(mesh)) {
        return materialCache.get(mesh);
    }
    const materials = [];
    mesh.traverse((child) => {
        if (child.isMesh && child.material) {
            materials.push(...getUniqueMaterials(child));
        }
    });
    materialCache.set(mesh, materials);
    return materials;
}

function resetOptionsScroll() {
    const container = document.getElementById('options-container');
    if (!container) return;

    if (window.innerWidth > 767) {
        const currentStep = configSteps[currentIndex];
        if (currentStep?.type === 'pill') {
            container.scrollLeft = 0;
            return;
        }

        const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
        container.scrollLeft = maxScroll > 0 ? maxScroll / 2 : 0;
        return;
    }

    container.scrollLeft = 0;
}

// ========================================
// GLOBAL VARIABLES (Accessibili da tutte le funzioni)
// ========================================
const UI_HEIGHT_DESKTOP = 180;
const UI_HEIGHT_MOBILE = 160;

function getViewportHeight() {
    return window.visualViewport ? window.visualViewport.height : window.innerHeight;
}

function syncViewportHeightVar() {
    document.documentElement.style.setProperty('--vh', `${getViewportHeight()}px`);
}

function getSafeAreaBottom() {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--safe-area-bottom').trim();
    const safeArea = parseFloat(value);
    return Number.isFinite(safeArea) ? safeArea : 0;
}

function getBottomUIHeight() {
    const bottomUI = document.getElementById('bottom-ui');
    if (bottomUI) {
        const measuredHeight = bottomUI.getBoundingClientRect().height;
        if (Number.isFinite(measuredHeight) && measuredHeight > 0) return measuredHeight;
    }
    const baseHeight = window.innerWidth <= 767 ? UI_HEIGHT_MOBILE : UI_HEIGHT_DESKTOP;
    return baseHeight + getSafeAreaBottom();
}

function getTopUIHeight() {
    const elements = [
        document.querySelector('.finish-btn-top'),
        document.querySelector('.close-btn'),
        document.querySelector('.product-info-top-left')
    ];
    let maxBottom = 0;
    elements.forEach((el) => {
        if (!el) return;
        const rect = el.getBoundingClientRect();
        if (Number.isFinite(rect.bottom) && rect.bottom > maxBottom) {
            maxBottom = rect.bottom;
        }
    });
    return maxBottom > 0 ? maxBottom + 8 : 0;
}

function getCanvasSize() {
    const canvasContainer = document.getElementById('canvas-container');
    if (canvasContainer) {
        const rect = canvasContainer.getBoundingClientRect();
        if (Number.isFinite(rect.width) && Number.isFinite(rect.height) && rect.width > 1 && rect.height > 1) {
            return { width: rect.width, height: rect.height };
        }
    }
    return {
        width: window.innerWidth,
        height: Math.max(1, getViewportHeight() - getBottomUIHeight())
    };
}

let resizeRaf = null;
function scheduleResize() {
    if (resizeRaf) return;
    resizeRaf = requestAnimationFrame(() => {
        resizeRaf = null;
        onWindowResize();
    });
}

const scene = new THREE.Scene();
scene.background = new THREE.Color(0xf6f6f6);

let camera, renderer, controls;
let screenshotRenderer = null;
let miscelatoreModel = null;
let rotationRoot = null;
let baseMeshes = [];
let logoMeshes = [];
let logo2Meshes = [];
let culoMeshes = [];
let textMeshes = [];
let isModelLoaded = false;
let hasSavedViewState = false;
let renderRaf = null;
let renderUntil = 0;

function requestRender(durationMs = 0) {
    if (durationMs > 0) {
        renderUntil = Math.max(renderUntil, performance.now() + durationMs);
    }

    if (renderRaf) return;
    renderRaf = requestAnimationFrame(renderFrame);
}

function renderFrame(now) {
    renderRaf = null;
    const controlsChanged = controls ? controls.update() : false;

    if (renderer && camera) {
        renderer.render(scene, camera);
    }

    if (controlsChanged || now < renderUntil) {
        requestRender();
    }
}

// ========================================
// FUNZIONE DI INIZIALIZZAZIONE CAMERA E RENDERER
// ========================================
function initThreeJS() {
    syncViewportHeightVar();
    const { width: containerWidth, height: containerHeight } = getCanvasSize();

    camera = new THREE.PerspectiveCamera(50, containerWidth / containerHeight, 0.1, 1000);

    renderer = new THREE.WebGLRenderer({ antialias: true, powerPreference: 'high-performance' });
    renderer.setSize(containerWidth, containerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.75));
    renderer.shadowMap.enabled = false;
    document.getElementById('canvas-container').appendChild(renderer.domElement);

    controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.05;
    // Rotazione libera a 360 gradi - nessun limite
    controls.minDistance = 0;
    controls.maxDistance = Infinity;
    controls.enableRotate = true;
    controls.rotateSpeed = 1.0; // Rotazione classica
    // NESSUN VINCOLO DI ROTAZIONE - 360 gradi liberi su tutti gli assi
    controls.minPolarAngle = -Infinity;
    controls.maxPolarAngle = Infinity;
    controls.minAzimuthAngle = -Infinity;
    controls.maxAzimuthAngle = Infinity;
    controls.addEventListener('start', () => requestRender(1000));
    controls.addEventListener('change', () => requestRender(500));
    controls.addEventListener('end', () => requestRender(500));

    // Ambient light - illuminazione generale soft
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);

    // Directional light principale (sole)
    const dirLight = new THREE.DirectionalLight(0xffffff, 1.2);
    dirLight.position.set(8, 12, 6);
    dirLight.castShadow = false;
    scene.add(dirLight);

    // Fill light (luce secondaria per ammorbidire le ombre)
    const fillLight = new THREE.DirectionalLight(0x87ceeb, 0.5);
    fillLight.position.set(-5, 8, -8);
    fillLight.castShadow = false; // No shadow per performance
    scene.add(fillLight);

    // Back light (luce da dietro per separare dall'ambiente)
    const backLight = new THREE.PointLight(0xffffff, 0.3);
    backLight.position.set(-10, 5, -15);
    backLight.castShadow = false;
    scene.add(backLight);

    // Piano per ricevere ombre
    const planeGeometry = new THREE.PlaneGeometry(100, 100);
    const planeMaterial = new THREE.ShadowMaterial({ opacity: 0.4 });
    const plane = new THREE.Mesh(planeGeometry, planeMaterial);
    plane.rotation.x = -Math.PI / 2;
    plane.position.y = -10;
    plane.receiveShadow = true;
    scene.add(plane);

    scheduleResize();
    requestRender();
}

// ========================================
// FUNZIONE DI INQUADRATURA RESPONSIVE
// ========================================
function frameModel() {
    if (!rotationRoot || !isModelLoaded) return;

    const box = new THREE.Box3().setFromObject(rotationRoot);
    const size = box.getSize(new THREE.Vector3());
    const center = box.getCenter(new THREE.Vector3());

    const maxDim = Math.max(size.x, size.y, size.z);
    
    const fov = camera.fov * (Math.PI / 180);
    let cameraDistance = Math.abs(maxDim / Math.tan(fov / 2));

    // Margin da mantenere dai bordi (in percentuale: 0.1 = 10% spazio libero)
    const marginPercent = window.innerWidth <= 767 ? 0.06 : 0.1;
    const { height: canvasHeight } = getCanvasSize();
    const topReservePx = getTopUIHeight();
    const bottomReservePx = getBottomUIHeight();
    const safeCanvasHeight = Math.max(1, canvasHeight);
    const clampedTopPx = Math.min(safeCanvasHeight - 1, Math.max(0, topReservePx));
    const clampedBottomPx = Math.max(clampedTopPx + 1, safeCanvasHeight - bottomReservePx);
    const availableHeight = Math.min(2, (Math.max(1, clampedBottomPx - clampedTopPx) / safeCanvasHeight) * 2);
    const desiredCenterPx = (clampedTopPx + clampedBottomPx) / 2;
    const desiredCenterY = 1 - (desiredCenterPx / safeCanvasHeight) * 2;
    
    // Posiziona la camera
    camera.position.set(center.x, center.y + cameraDistance, center.z);
    camera.lookAt(center);
    camera.updateProjectionMatrix();
    camera.updateMatrixWorld(true);
    
    // Proietta i corner del bounding box sulla screen space per misurare l'occupazione
    const corners = [
        new THREE.Vector3(box.min.x, box.min.y, box.min.z),
        new THREE.Vector3(box.max.x, box.min.y, box.min.z),
        new THREE.Vector3(box.min.x, box.max.y, box.min.z),
        new THREE.Vector3(box.max.x, box.max.y, box.min.z),
        new THREE.Vector3(box.min.x, box.min.y, box.max.z),
        new THREE.Vector3(box.max.x, box.min.y, box.max.z),
        new THREE.Vector3(box.min.x, box.max.y, box.max.z),
        new THREE.Vector3(box.max.x, box.max.y, box.max.z)
    ];
    
    let minScreenX = Infinity, maxScreenX = -Infinity;
    let minScreenY = Infinity, maxScreenY = -Infinity;
    
    corners.forEach(corner => {
        const screenPos = corner.project(camera);
        minScreenX = Math.min(minScreenX, screenPos.x);
        maxScreenX = Math.max(maxScreenX, screenPos.x);
        minScreenY = Math.min(minScreenY, screenPos.y);
        maxScreenY = Math.max(maxScreenY, screenPos.y);
    });
    
    // Calcola quanto spazio occupa il modello (-1 a 1 è il viewport)
    const screenWidth = maxScreenX - minScreenX;
    const screenHeight = maxScreenY - minScreenY;
    
    // Calcola il fattore di zoom per stare dentro lo spazio disponibile con margine
    const availableWidth = 2 * (1 - marginPercent); // Da -0.9 a 0.9

    if (!Number.isFinite(screenWidth) || !Number.isFinite(screenHeight) || screenWidth <= 0 || screenHeight <= 0) {
        return;
    }
    
    if (!Number.isFinite(availableWidth) || !Number.isFinite(availableHeight) || availableWidth <= 0 || availableHeight <= 0) {
        return;
    }
    
    // Fattore distanza camera: < 1 zoom in, > 1 zoom out
    let zoomFactor = Math.max(screenWidth / availableWidth, screenHeight / availableHeight);
    zoomFactor = Math.max(zoomFactor, 0.2); // Consenti più zoom-in per modelli piccoli
    
    // Applica lo zoom
    cameraDistance *= zoomFactor;
    camera.position.set(center.x, center.y + cameraDistance, center.z);
    camera.lookAt(center);
    camera.updateMatrixWorld(true);

    const centerNdc = center.clone().project(camera);
    const deltaNdcY = desiredCenterY - centerNdc.y;
    controls.target.copy(center);
    if (Math.abs(deltaNdcY) > 0.001) {
        const centerCam = center.clone().applyMatrix4(camera.matrixWorldInverse);
        const deltaYCam = deltaNdcY * -centerCam.z * Math.tan(fov / 2);
        const offset = new THREE.Vector3(0, deltaYCam, 0);
        offset.applyMatrix3(new THREE.Matrix3().setFromMatrix4(camera.matrixWorld));
        camera.position.add(offset);
        controls.target.add(offset);
        camera.lookAt(controls.target);
    }
    controls.update();
    controls.saveState();
    hasSavedViewState = true;
    requestRender();
}

function resetViewToDefault() {
    animateViewReset();
}

// ========================================
// FUNZIONE DI RESIZE (responsive)
// ========================================
function onWindowResize() {
    syncViewportHeightVar();
    const { width: containerWidth, height: containerHeight } = getCanvasSize();

    camera.aspect = containerWidth / containerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(containerWidth, containerHeight);

    if (isModelLoaded) {
        frameModel();
    } else {
        requestRender();
    }
}

// ========================================
// SETUP THREE.JS E CARICAMENTO MODELLO
// ========================================
initThreeJS();

const loader = new GLTFLoader();
loader.setCrossOrigin('anonymous');

function loadModel() {
    return new Promise((resolve, reject) => {
        loader.load(MODEL_URL, resolve, undefined, reject);
    });
}

function isMissingDracoLoaderError(error) {
    const message = String(error?.message || error || '').toLowerCase();
    return message.includes('dracoloader') || message.includes('khr_draco_mesh_compression');
}

async function enableDracoLoader() {
    const { DRACOLoader } = await import('three/addons/loaders/DRACOLoader.js');
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath(DRACO_DECODER_PATH);
    dracoLoader.setDecoderConfig({ type: 'wasm' });
    loader.setDRACOLoader(dracoLoader);
}

async function setupLoadedModel(gltf) {
    miscelatoreModel = gltf.scene;

    const box = new THREE.Box3().setFromObject(miscelatoreModel);
    const size = box.getSize(new THREE.Vector3());
    const maxDim = Math.max(size.x, size.y, size.z);

    let scaleFactor = 1;
    if (maxDim > 10) {
        scaleFactor = 5 / maxDim;
    } else if (maxDim < 0.5) {
        scaleFactor = 2 / maxDim;
    }

    miscelatoreModel.scale.set(scaleFactor, scaleFactor, scaleFactor);
    const center = box.getCenter(new THREE.Vector3()).multiplyScalar(scaleFactor);

    rotationRoot = new THREE.Group();
    rotationRoot.position.copy(center);
    miscelatoreModel.position.sub(center);
    rotationRoot.add(miscelatoreModel);

    // Applica la rotazione iniziale specificata nel metafield (opzionale)
    if (INITIAL_ROTATION) {
        rotationRoot.rotation.set(INITIAL_ROTATION.x, INITIAL_ROTATION.y, INITIAL_ROTATION.z);
    }

    baseRotationEuler = rotationRoot.rotation.clone();

    scene.add(rotationRoot);

    const logoComponentsAdded = new Set();
    const baseComponentsAdded = new Set();

    const mainContainer = miscelatoreModel.children[0];

    if (mainContainer && mainContainer.children) {
        mainContainer.children.forEach((node) => {
            const nodeName = node.name.toLowerCase();

            if (nodeName.includes('base') && !baseComponentsAdded.has(node.name)) {
                baseComponentsAdded.add(node.name);

                const corpi = searchForBodies(node, 1) || searchForBodies(node, 2);

                const allMaterials = [];
                node.traverse((child) => {
                    if (child.isMesh && child.material) {
                        allMaterials.push(...getUniqueMaterials(child));
                    }
                });

                baseMeshes.push({
                    mesh: node,
                    name: node.name,
                    corpi: corpi,
                    allMaterials: allMaterials
                });
            }

            if (nodeName.includes('logo2') && !logoComponentsAdded.has(node.name)) {
                logoComponentsAdded.add(node.name);
                logo2Meshes.push({ mesh: node, name: node.name });
            }
            else if (nodeName.includes('logo') && !nodeName.includes('logo2') && !logoComponentsAdded.has(node.name)) {
                logoComponentsAdded.add(node.name);
                logoMeshes.push({ mesh: node, name: node.name });
            }

            if (nodeName.includes('culo') && !logoComponentsAdded.has(node.name)) {
                logoComponentsAdded.add(node.name);
                culoMeshes.push({ mesh: node, name: node.name });
            }
        });
    }

    const trackedTextNames = new Set();
    miscelatoreModel.traverse((node) => {
        const nodeName = node.name.toLowerCase();

        if ((nodeName.startsWith('3dlab') || nodeName === '3dl' || nodeName.includes('linea') || node.name === '3' || node.name === 'D' || node.name === 'L') && !trackedTextNames.has(node.name)) {
            trackedTextNames.add(node.name);
            textMeshes.push({ mesh: node, name: node.name });
        }
    });

    await restoreEditingConfiguration();
    isModelLoaded = true;
    generateConfigSteps();
    if (pendingPropertyReconstruction) {
        pendingPropertyReconstruction = false;
        reconstructChoicesFromCartProperties(editingCartItem?.properties);
    }
    frameModel();
    scheduleScreenshotRendererWarmup();
}

async function loadConfiguratorModel() {
    try {
        await setupLoadedModel(await loadModel());
    } catch (error) {
        if (!isMissingDracoLoaderError(error)) return;

        try {
            await enableDracoLoader();
            await setupLoadedModel(await loadModel());
        } catch (_) {}
    }
}

loadConfiguratorModel();

// ========================================
// GENERAZIONE DINAMICA DEI CONFIG STEPS
// ========================================
function searchForBodies(node, depth) {
    const corpi = [];
    const search = (parent, currentDepth) => {
        if (currentDepth > depth || !parent.children) return;
        
        parent.children.forEach((child) => {
            if (child.name.toLowerCase().includes('corpo')) {
                const corpoMaterials = [];
                child.traverse((meshNode) => {
                    if (meshNode.isMesh && meshNode.material) {
                        corpoMaterials.push(...getUniqueMaterials(meshNode));
                    }
                });
                
                if (corpoMaterials.length > 0) {
                    corpi.push({
                        node: child,
                        name: child.name,
                        materials: corpoMaterials
                    });
                }
            } else if (currentDepth < depth) {
                search(child, currentDepth + 1);
            }
        });
    };
    
    search(node, 0);
    return corpi;
}

const DEFAULT_LOGO_DARK_COLOR = 0x000000;
const DEFAULT_LOGO_LIGHT_COLOR = 0xCCFF00;

function normalizedLogoName(logoObj) {
    return logoObj
        ? formatLogoName(logoObj.name).replace(/[^A-Z0-9]/g, '')
        : '';
}

function isExtremitaComponent(step) {
    return [step.componentName, step.name, step.orderName, step.id].some((value) => (
        /estremit(?:a|à)/i.test(String(value || ''))
    ));
}

function findLogoColorReferenceStep(steps, excludedStepId = null) {
    let fallbackStep = null;

    for (let index = steps.length - 1; index >= 0; index -= 1) {
        const step = steps[index];
        if (step.type !== 'color' || step.id === excludedStepId) continue;
        if (!fallbackStep) fallbackStep = step;
        if (isExtremitaComponent(step)) return step;
    }

    return fallbackStep;
}

function syncDefaultLogoColor() {
    if (hasUserSelectedLogoColor) return;

    const selectedLogo = logoMeshes.find((logoObj) => logoObj.name === userChoices.logo_type);
    const logoName = normalizedLogoName(selectedLogo);
    if (!logoName.includes('3DLRACING') && !logoName.includes('3DLAB')) return;

    const logoStepIndex = configSteps.findIndex((step) => step.id === 'logo_type');
    if (logoStepIndex <= 0) return;

    const previousColorStep = findLogoColorReferenceStep(configSteps.slice(0, logoStepIndex));
    const previousColor = previousColorStep ? userChoices[previousColorStep.id] : null;
    if (!Number.isInteger(previousColor)) return;

    userChoices.logo_color = previousColor === DEFAULT_LOGO_LIGHT_COLOR
        ? DEFAULT_LOGO_DARK_COLOR
        : DEFAULT_LOGO_LIGHT_COLOR;
}

function syncDefaultLogo2Color() {
    if (hasUserSelectedLogo2Color) return;

    const selectedLogo2 = logo2Meshes.find((logoObj) => logoObj.name === userChoices.logo2_type);
    if (!normalizedLogoName(selectedLogo2).includes('3DLRACING')) return;

    const logo2StepIndex = configSteps.findIndex((step) => step.id === 'logo2_type');
    if (logo2StepIndex <= 0) return;

    const previousColorStep = findLogoColorReferenceStep(
        configSteps.slice(0, logo2StepIndex),
        'logo_color'
    );
    const previousColor = previousColorStep ? userChoices[previousColorStep.id] : null;
    if (!Number.isInteger(previousColor)) return;

    userChoices.logo2_color = previousColor === DEFAULT_LOGO_LIGHT_COLOR
        ? DEFAULT_LOGO_DARK_COLOR
        : DEFAULT_LOGO_LIGHT_COLOR;
}

function generateConfigSteps() {
    const baseColorOptions = [
        { hex: 0x000000, name: localizeConfiguratorColorName('Nero'), orderName: 'Nero' },
        { hex: 0x808080, name: localizeConfiguratorColorName('Grigio'), orderName: 'Grigio' },
        { hex: 0xFFFFFF, name: localizeConfiguratorColorName('Bianco'), orderName: 'Bianco' },
        { hex: 0xFE1FCF, name: localizeConfiguratorColorName('Rosa Fluo'), orderName: 'Rosa Fluo' },
        { hex: 0xFF0000, name: localizeConfiguratorColorName('Rosso'), orderName: 'Rosso' },
        { hex: 0xFF6600, name: localizeConfiguratorColorName('Arancione'), orderName: 'Arancione' },
        { hex: 0xFFFF00, name: localizeConfiguratorColorName('Giallo'), orderName: 'Giallo' },
        { hex: 0xCCFF00, name: localizeConfiguratorColorName('Giallo Fluo'), orderName: 'Giallo Fluo' },
        { hex: 0x008000, name: localizeConfiguratorColorName('Verde'), orderName: 'Verde' },
        { hex: 0x39FF14, name: localizeConfiguratorColorName('Verde Fluo'), orderName: 'Verde Fluo' },
        { hex: 0x00BFFF, name: localizeConfiguratorColorName('Azzurro'), orderName: 'Azzurro' },
        { hex: 0x0000FF, name: localizeConfiguratorColorName('Blu'), orderName: 'Blu' },
        { hex: 0x8A2BE2, name: localizeConfiguratorColorName('Viola'), orderName: 'Viola' }
    ];

    // Inizializza configSteps vuoto
    configSteps = [];
    lastRenderedStepIndex = null;
    lastAppliedRotationKey = null;

    // STEP 1: Selezione Base (SOLO se ci sono MULTIPLE basi)
    if (baseMeshes.length > 1) {
        const baseOptions = baseMeshes.map((baseObj) => ({
            id: baseObj.name,
            label: formatLogoName(baseObj.name)
        }));

        configSteps.push({
            id: 'base_type',
            name: localizeConfiguratorStepName('Tipo Base'),
            orderName: 'Tipo Base',
            type: 'pill',
            options: baseOptions
        });

        // AUTO-SELEZIONA LA PRIMA BASE SOLO se non è ancora stata scelta una base
        if (!userChoices.base_type) {
            userChoices.base_type = baseMeshes[0].name;
        }
    } else if (baseMeshes.length === 1) {
        if (!userChoices.base_type) {
            userChoices.base_type = baseMeshes[0].name;
        }
    }

    // STEP 2: Colori Corpi o Colore Base (dinamico in base alla base selezionata)
    const selectedBase = baseMeshes.find(b => b.name === userChoices.base_type);
    
    if (selectedBase) {
        if (selectedBase.corpi && selectedBase.corpi.length > 0) {
            // HA CORPI: crea uno step per ogni corpo
            selectedBase.corpi.forEach((corpo, idx) => {
                const stepId = `corpo_${idx}`;
                
                // Estrai il nome del corpo e rimuovi "corpo " dal inizio
                let corpoName = corpo.name.toLowerCase();
                corpoName = corpoName.replace(/^corpo\s*[_-]?\s*/, ''); // Rimuove "corpo ", "corpo_", "corpo-"
                corpoName = corpoName.replace(/[_-]/g, ' '); // Sostituisce underscore e trattini con spazi
                corpoName = corpoName.replace(/\.\d+$/, ''); // Rimuove numeri finali (es. .001)
                corpoName = corpoName.replace(/^\d+\s*/, ''); // Rimuove l'indice iniziale, preservando numeri interni (es. "Riga 1")
                corpoName = corpoName.trim();
                
                // Formatta il nome (capitalizza prima lettera di ogni parola)
                const rawStepLabel = selectedBase.corpi.length === 1
                    ? 'Colore Base' 
                    : 'Colore ' + corpoName.split(/\s+/).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
                const stepLabel = localizeConfiguratorStepName(rawStepLabel);
                
                configSteps.push({
                    id: stepId,
                    name: stepLabel,
                    orderName: rawStepLabel,
                    componentName: corpo.name,
                    type: 'color',
                    options: baseColorOptions
                });
                
                // Inizializza colori: alternati nero e giallo fluo
                if (userChoices[stepId] === undefined) {
                    userChoices[stepId] = idx % 2 === 0 ? 0x000000 : 0xCCFF00;
                }
            });
        }

        // Aggiungi lo step "Colore Base" SOLO se NON ci sono corpi
        const numCorpi = (selectedBase.corpi && selectedBase.corpi.length) || 0;
        if (numCorpi === 0) {
            configSteps.push({
                id: 'base_color',
                name: localizeConfiguratorStepName('Colore Base'),
                orderName: 'Colore Base',
                componentName: selectedBase.name,
                type: 'color',
                options: baseColorOptions
            });
            
            // Inizializza colore base se non è stato ancora scelto
            if (userChoices.base_color === undefined) {
                userChoices.base_color = 0x000000;
            }
            
        }
    }

    if (logoMeshes.length > 0) {
        const logoOptions = [
            { id: null, label: configuratorText('noLogo'), orderLabel: CONFIGURATOR_TEXT.it.noLogo },
            ...logoMeshes.map((logoObj) => ({
                id: logoObj.name,
                label: formatLogoName(logoObj.name)
            }))
        ];

        if (!hasAppliedDefaultLogo) {
            const defaultLogo = logoMeshes.find((logoObj) => normalizedLogoName(logoObj).includes('3DLRACING'))
                || logoMeshes.find((logoObj) => normalizedLogoName(logoObj).includes('3DLAB'));
            if (defaultLogo) {
                userChoices.logo_type = defaultLogo.name;
            }
            hasAppliedDefaultLogo = true;
        }

        configSteps.push({
            id: 'logo_type',
            name: localizeConfiguratorStepName('Logo'),
            orderName: 'Logo',
            type: 'pill',
            options: logoOptions
        });

        // STEP 4: Colore Logo
        configSteps.push({
            id: 'logo_color',
            name: localizeConfiguratorStepName('Colore Logo'),
            orderName: 'Colore Logo',
            type: 'color',
            options: baseColorOptions
        });
    }

    // STEP 5: Selezione Logo2 (se disponibile)
    if (logo2Meshes.length > 0) {
        const logo2Options = [
            { id: null, label: configuratorText('noLogo'), orderLabel: CONFIGURATOR_TEXT.it.noLogo },
            ...logo2Meshes.map((logoObj) => ({
                id: logoObj.name,
                label: formatLogoName(logoObj.name)
            }))
        ];

        if (!hasAppliedDefaultLogo2) {
            const defaultLogo2 = logo2Meshes.find((logoObj) => normalizedLogoName(logoObj).includes('3DLRACING'));
            if (defaultLogo2) {
                userChoices.logo2_type = defaultLogo2.name;
            }
            hasAppliedDefaultLogo2 = true;
        }

        configSteps.push({
            id: 'logo2_type',
            name: localizeConfiguratorStepName('Logo Secondario'),
            orderName: 'Logo Secondario',
            type: 'pill',
            options: logo2Options
        });

        // STEP 6: Colore Logo2
        configSteps.push({
            id: 'logo2_color',
            name: localizeConfiguratorStepName('Colore Logo Secondario'),
            orderName: 'Colore Logo Secondario',
            type: 'color',
            options: baseColorOptions
        });
    }

    // STEP 7: Selezione Culo (se disponibile)
    if (culoMeshes.length > 0) {
        const culoOptions = culoMeshes.map((culoObj) => ({
            id: culoObj.name,
            label: formatLogoName(culoObj.name)
        }));

        configSteps.push({
            id: 'culo_type',
            name: localizeConfiguratorStepName('Fori'),
            orderName: 'Fori',
            type: 'pill',
            options: culoOptions
        });

        // STEP 8: Colore Fori
        configSteps.push({
            id: 'culo_color',
            name: localizeConfiguratorStepName('Colore Fori'),
            orderName: 'Colore Fori',
            type: 'color',
            options: baseColorOptions
        });
    }

    // Aggiorna l'HTML con il numero di componenti
    const totalComponents = configSteps.length;
    const totalComponentsEl = document.getElementById('total-components');
    if (totalComponentsEl) totalComponentsEl.innerText = totalComponents;
    
    // Imposta il primo culo come default (sempre attivo)
    if (culoMeshes.length > 0 && !userChoices.culo_type) {
        userChoices.culo_type = culoMeshes[0].name;
    }

    syncDefaultLogoColor();
    syncDefaultLogo2Color();
    
    renderBottomUI();
    updateModel();
}

const SCREENSHOT_EXPORT_SIDE = 512;
const SCREENSHOT_WEBP_QUALITY = 0.82;

function getScreenshotRenderer() {
    if (!screenshotRenderer) {
        screenshotRenderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: false,
            preserveDrawingBuffer: true,
            powerPreference: 'high-performance'
        });
        screenshotRenderer.setPixelRatio(1);
        screenshotRenderer.setSize(SCREENSHOT_EXPORT_SIDE, SCREENSHOT_EXPORT_SIDE, false);
    }

    screenshotRenderer.setClearColor(scene.background || 0xf6f6f6, 1);
    screenshotRenderer.toneMapping = renderer.toneMapping;
    screenshotRenderer.toneMappingExposure = renderer.toneMappingExposure;
    screenshotRenderer.outputColorSpace = renderer.outputColorSpace;

    return screenshotRenderer;
}

function scheduleScreenshotRendererWarmup() {
    const warmup = () => {
        if (!renderer || !isModelLoaded || screenshotRenderer) return;
        try {
            const captureRenderer = getScreenshotRenderer();
            captureRenderer.compile(scene, camera);
            captureRenderer.render(scene, camera);
        } catch (_) {
            // La cattura mostrera un errore esplicito se il browser non puo creare il contesto WebGL.
        }
    };

    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(warmup, { timeout: 2000 });
    } else {
        window.setTimeout(warmup, 0);
    }
}

function canvasToBlob(canvas) {
    return new Promise((resolve, reject) => {
        if (typeof canvas.toBlob !== 'function') {
            reject(new Error(configuratorText('previewUnsupported')));
            return;
        }

        canvas.toBlob((blob) => {
            if (blob) {
                resolve(blob);
                return;
            }

            // Fallback per WebView che non espongono l'encoder WebP del canvas.
            canvas.toBlob((fallbackBlob) => {
                if (fallbackBlob) resolve(fallbackBlob);
                else reject(new Error(configuratorText('previewGenerateError')));
            }, 'image/png');
        }, 'image/webp', SCREENSHOT_WEBP_QUALITY);
    });
}

async function captureTopScreenshotBlob() {
    if (!renderer || !camera || !rotationRoot || !isModelLoaded) return null;

    const previousRotation = rotationRoot.rotation.clone();
    let blobPromise = null;

    try {
        const screenshotRotation = resolveScreenViewRotation();
        rotationRoot.rotation.copy(screenshotRotation);
        rotationRoot.updateMatrixWorld(true);

        const box = new THREE.Box3().setFromObject(rotationRoot);
        const center = box.getCenter(new THREE.Vector3());
        const size = box.getSize(new THREE.Vector3());
        const margin = 1.12;

        // Ortho top-view evita qualsiasi distorsione prospettica/stretch.
        const halfExtent = Math.max(size.x, size.z) * 0.5 * margin;
        const distance = Math.max(2, size.y + Math.max(size.x, size.z) * 1.5);
        const near = 0.01;
        const far = distance + size.y * 4 + 50;

        const topCamera = new THREE.OrthographicCamera(
            -halfExtent,
            halfExtent,
            halfExtent,
            -halfExtent,
            near,
            far
        );
        topCamera.up.set(0, 0, -1);
        topCamera.position.set(center.x, center.y + distance, center.z);
        topCamera.lookAt(center);
        topCamera.updateProjectionMatrix();

        const captureRenderer = getScreenshotRenderer();
        captureRenderer.render(scene, topCamera);
        blobPromise = canvasToBlob(captureRenderer.domElement);
    } finally {
        // Ripristina subito la vista mentre la codifica Blob prosegue in modo asincrono.
        rotationRoot.rotation.copy(previousRotation);
        rotationRoot.updateMatrixWorld(true);
        requestRender();
    }

    return blobPromise ? await blobPromise : null;
}

window.addEventListener('pagehide', () => {
    if (!screenshotRenderer) return;
    screenshotRenderer.dispose();
    screenshotRenderer = null;
});

// ========================================
// EVENT LISTENER PER RESIZE (Responsive)
// ========================================
window.addEventListener('resize', scheduleResize);
if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleResize);
    window.visualViewport.addEventListener('scroll', scheduleResize);
}

const canvasContainer = document.getElementById('canvas-container');
const bottomUI = document.getElementById('bottom-ui');
if (window.ResizeObserver && (canvasContainer || bottomUI)) {
    const resizeObserver = new ResizeObserver(() => scheduleResize());
    if (canvasContainer) resizeObserver.observe(canvasContainer);
    if (bottomUI) resizeObserver.observe(bottomUI);
}

// ========================================
// NUOVA LOGICA UI (Stile Nike By You)
// ========================================

// configSteps verrà generato dinamicamente nel loader.load()
let configSteps = [];
let currentIndex = 0;
let lastRenderedStepIndex = null;
let lastAppliedRotationKey = null;
let hasAppliedDefaultLogo = false;
let hasAppliedDefaultLogo2 = false;
let hasUserSelectedLogoColor = false;
let hasUserSelectedLogo2Color = false;
let userChoices = { 
    base_type: null,
    base_color: 0x000000,
    logo_type: null,
    logo_color: 0xCCFF00,
    logo2_type: null,
    logo2_color: 0xffffff,
    culo_type: null,
    culo_color: 0x000000
};

const titleEl = document.getElementById('step-title');
const optionsContainer = document.getElementById('options-container');
const stepCounterEl = document.createElement('span');
stepCounterEl.className = 'step-counter';
const modalEl = document.getElementById('component-modal');
const modalEl2 = document.getElementById('component-modal-2');
const configuratorWrapper = document.getElementById('configuratore-wrapper');
const loadingOverlay = document.getElementById('configurator-loading-overlay');
let isAddingToCart = false;
let stepTransitionTimeout = null;

function setConfiguratorLoadingState(isLoading, message) {
    if (!configuratorWrapper || !loadingOverlay) return;
    configuratorWrapper.classList.toggle('is-loading', isLoading);
    loadingOverlay.setAttribute('aria-hidden', (!isLoading).toString());
    if (message) {
        const textEl = loadingOverlay.querySelector('.configurator-loading-text');
        if (textEl) textEl.textContent = message;
    }
}

function playStepTransition(direction) {
    if (!bottomUI || !direction) return;

    const className = direction === 'prev' ? 'step-slide-prev' : 'step-slide-next';
    bottomUI.classList.remove('step-slide-next', 'step-slide-prev');
    void bottomUI.offsetWidth;
    bottomUI.classList.add(className);

    if (stepTransitionTimeout) {
        window.clearTimeout(stepTransitionTimeout);
    }
    stepTransitionTimeout = window.setTimeout(() => {
        bottomUI.classList.remove(className);
        stepTransitionTimeout = null;
    }, 220);
}

// 2. Funzione per Disegnare la Barra Inferiore
function renderBottomUI() {
    const step = configSteps[currentIndex];
    if (!step) return;
    const didChangeStep = currentIndex !== lastRenderedStepIndex;

    if (didChangeStep) {
        applyStepRotation(currentIndex + 1);
        resetViewToDefault();
        lastRenderedStepIndex = currentIndex;
        trackConfigurator('viewStep', {
            index: currentIndex + 1,
            id: step.id,
            name: step.orderName || step.name,
            total: configSteps.length,
            editing: Boolean(editingCartItem)
        });
    }

    stepCounterEl.textContent = `${currentIndex + 1}/${configSteps.length}`;
    titleEl.textContent = step.name;
    titleEl.appendChild(stepCounterEl);

    optionsContainer.classList.toggle('pill-options', step.type === 'pill');
    
    optionsContainer.innerHTML = ''; // Svuota opzioni precedenti
    const fragment = document.createDocumentFragment();

    step.options.forEach((opt, idx) => {
        if (step.type === 'color') {
            const swatchContainer = document.createElement('div');
            swatchContainer.className = `color-swatch-container ${userChoices[step.id] === opt.hex ? 'active' : ''}`;
            
            const swatch = document.createElement('div');
            swatch.className = `color-swatch ${userChoices[step.id] === opt.hex ? 'active' : ''}`;
            const hexColor = '#' + opt.hex.toString(16).padStart(6, '0');
            swatch.style.backgroundColor = hexColor;
            swatch.style.cursor = 'pointer';
            swatch.onclick = () => {
                userChoices[step.id] = opt.hex;
                if (step.id === 'logo_color') {
                    hasUserSelectedLogoColor = true;
                } else if (step.id === 'logo2_color') {
                    hasUserSelectedLogo2Color = true;
                }
                syncDefaultLogoColor();
                syncDefaultLogo2Color();
                renderBottomUI();
                updateModel();
            };
            
            const label = document.createElement('span');
            label.className = 'color-name';
            label.innerText = opt.name || '';
            
            swatchContainer.appendChild(swatch);
            swatchContainer.appendChild(label);
            fragment.appendChild(swatchContainer);
        } else if (step.type === 'pill') {
            const btn = document.createElement('button');
            btn.className = `pill-btn ${userChoices[step.id] === opt.id ? 'active' : ''}`;
            btn.setAttribute('aria-label', opt.label);
            btn.title = opt.label;

            const btnLabel = document.createElement('span');
            btnLabel.className = 'pill-btn-label';
            splitPillLabel(opt.label).forEach((line) => {
                const lineEl = document.createElement('span');
                lineEl.className = 'pill-btn-label-line';
                lineEl.textContent = line;
                btnLabel.appendChild(lineEl);
            });
            btn.appendChild(btnLabel);
            btn.onclick = () => { 
                userChoices[step.id] = opt.id;
                
                // Se cambio base, rigenera gli step restando su "Tipo Base".
                if (step.id === 'base_type') {
                    generateConfigSteps();
                    return;
                }

                if (step.id === 'logo_type') {
                    syncDefaultLogoColor();
                    syncDefaultLogo2Color();
                }
                if (step.id === 'logo2_type') syncDefaultLogo2Color();
                
                renderBottomUI();
                updateModel();
            };
            fragment.appendChild(btn);
        }
    });

    optionsContainer.appendChild(fragment);

    if (didChangeStep) {
        // Posiziona la scrollbar solo quando cambia step, non quando si seleziona un'opzione.
        requestAnimationFrame(resetOptionsScroll);
    }
}

// 3. Funzione per Aggiornare il Modello 3D
function updateModel() {
    const selectedBase = baseMeshes.find(b => b.name === userChoices.base_type);
    
    // Gestione visibilità basi
    if (baseMeshes.length > 0) {
        baseMeshes.forEach((baseObj) => {
            const shouldBeVisible = (baseMeshes.length === 1 || userChoices.base_type === baseObj.name);
            baseObj.mesh.visible = shouldBeVisible;
        });
    }
    
    // Colorazione della base selezionata
    if (selectedBase) {
        if (selectedBase.corpi && selectedBase.corpi.length > 0) {
            // HA CORPI: colora ogni corpo individualmente
            selectedBase.corpi.forEach((corpo, idx) => {
                const stepId = `corpo_${idx}`;
                const color = userChoices[stepId] || 0x000000;
                
                corpo.materials.forEach((mat) => {
                    mat.color.setHex(color);
                    mat.needsUpdate = true;
                });
            });
        } else {
            // NO CORPI: colora tutta la base con colore unico
            selectedBase.allMaterials.forEach((mat) => {
                mat.color.setHex(userChoices.base_color);
                mat.needsUpdate = true;
            });
        }
    }
    
    // ========================================
    // GESTIONE LOGHI
    // ========================================
    if (logoMeshes.length > 0) {
        logoMeshes.forEach((logoObj) => {
            const isSelected = (userChoices.logo_type === logoObj.name);
            logoObj.mesh.visible = isSelected;
            
            if (isSelected) {
                const logoMaterials = collectMaterials(logoObj.mesh);
                logoMaterials.forEach((material) => {
                    material.color.setHex(userChoices.logo_color);
                    material.needsUpdate = true;
                });
            }
        });
    }
    
    // ========================================
    // GESTIONE LOGHI2
    // ========================================
    if (logo2Meshes.length > 0) {
        logo2Meshes.forEach((logoObj) => {
            const isSelected = (userChoices.logo2_type === logoObj.name);
            logoObj.mesh.visible = isSelected;
            
            if (isSelected) {
                const logoMaterials = collectMaterials(logoObj.mesh);
                logoMaterials.forEach((material) => {
                    material.color.setHex(userChoices.logo2_color);
                    material.needsUpdate = true;
                });
            }
        });
    }
    
    // ========================================
    // GESTIONE CULO
    // ========================================
    if (culoMeshes.length > 0) {
        culoMeshes.forEach((culoObj) => {
            const isSelected = (userChoices.culo_type === culoObj.name);
            culoObj.mesh.visible = isSelected;
            
            if (isSelected) {
                const culoMaterials = collectMaterials(culoObj.mesh);
                culoMaterials.forEach((material) => {
                    material.color.setHex(userChoices.culo_color);
                    material.needsUpdate = true;
                });
            }
        });
    }
    
    // ========================================
    // GESTIONE TESTO "3DL", "3DLAB" E "LINEA" (sincronizzati con logo_color)
    // ========================================
    if (textMeshes.length > 0) {
        const hideBrandText = [userChoices.logo_type, userChoices.logo2_type]
            .map((logoName) => logoName ? formatLogoName(logoName) : '')
            .some((logoName) => logoName.includes('3DL RACING') || logoName.includes('3DLAB'));

        textMeshes.forEach((textObj) => {
            const textName = textObj.name.trim().toLowerCase();
            const isBrandText = textName.startsWith('3dlab')
                || textName === '3dl'
                || textName === '3'
                || textName === 'd'
                || textName === 'l';
            const shouldBeVisible = !(hideBrandText && isBrandText);
            textObj.mesh.visible = shouldBeVisible;

            if (!shouldBeVisible) return;

            const textMaterials = collectMaterials(textObj.mesh);
            textMaterials.forEach((material) => {
                material.color.setHex(userChoices.logo_color);
                material.needsUpdate = true;
            });
        });
    }

    requestRender();
}

// 4. Navigazione e Modale Componenti
window.nextStep = () => { 
    if (!configSteps.length) return;
    currentIndex = (currentIndex + 1) % configSteps.length;
    renderBottomUI();
    playStepTransition('next');
};

window.prevStep = () => { 
    if (!configSteps.length) return;
    currentIndex = (currentIndex - 1 + configSteps.length) % configSteps.length;
    renderBottomUI();
    playStepTransition('prev');
};

window.toggleStepsModal = () => {
    const stepsModal = document.getElementById('steps-modal');
    stepsModal.classList.toggle('hidden');
    if (!stepsModal.classList.contains('hidden')) {
        renderStepsList();
    }
};

function renderStepsList() {
    const stepsList = document.getElementById('steps-list');
    stepsList.innerHTML = '';
    
    configSteps.forEach((step, index) => {
        const li = document.createElement('li');
        li.className = `step-item ${currentIndex === index ? 'active' : ''}`;
        li.innerText = step.name;
        li.onclick = () => {
            currentIndex = index;
            renderBottomUI();
            toggleStepsModal();
        };
        stepsList.appendChild(li);
    });
}

window.toggleComponentList = () => {
    modalEl.classList.toggle('hidden');
    if (!modalEl.classList.contains('hidden')) {
        renderComponentList('logo', logoMeshes, 'logo_type');
    }
};

window.toggleComponentList2 = () => {
    modalEl2.classList.toggle('hidden');
    if (!modalEl2.classList.contains('hidden')) {
        renderComponentList('logo2', logo2Meshes, 'logo2_type');
    }
};

function renderComponentList(type, meshes, choiceKey) {
    const listId = type === 'logo' ? 'component-list' : 'component-list-2';
    const componentList = document.getElementById(listId);
    componentList.innerHTML = '';
    
    if (meshes.length === 0) {
        componentList.innerHTML = `<li style="color: #888;">${configuratorText('noLogoAvailable')}</li>`;
        return;
    }
    
    const noneLogoLi = document.createElement('li');
    noneLogoLi.className = `component-item ${userChoices[choiceKey] === null ? 'active' : ''}`;
    noneLogoLi.innerText = configuratorText('noLogo');
    noneLogoLi.onclick = () => {
        userChoices[choiceKey] = null;
        renderBottomUI();
        updateModel();
        (type === 'logo' ? toggleComponentList : toggleComponentList2)();
    };
    componentList.appendChild(noneLogoLi);
    
    meshes.forEach((logoObj) => {
        const displayName = formatLogoName(logoObj.name);
        
        const li = document.createElement('li');
        li.className = `component-item ${userChoices[choiceKey] === logoObj.name ? 'active' : ''}`;
        li.innerText = displayName;
        li.onclick = () => {
            userChoices[choiceKey] = logoObj.name;
            renderBottomUI();
            updateModel();
            (type === 'logo' ? toggleComponentList : toggleComponentList2)();
        };
        componentList.appendChild(li);
    });
}

const ADD_TO_CART_BUTTON_SELECTOR = '.finish-btn-top, #btn-add-cart';
const CART_DRAWER_REDIRECT_FLAG = 'open_cart_drawer_from_configurator';
const CART_DRAWER_REDIRECT_QUERY_PARAM = '_open_configurator_cart';
const LOCAL_THEME_HOSTS = new Set(['127.0.0.1', 'localhost', '::1']);
const CUSTOM_PRODUCT_API_BASE =  'https://staging.shop3dlab.cloud';
const configuratorCartSuccess = document.getElementById('configurator-cart-success');
const configuratorCartSuccessMessage = configuratorCartSuccess?.querySelector('.configurator-cart-success-message');
const configuratorCartSuccessDismiss = document.getElementById('configurator-cart-success-dismiss');
const configuratorCartLink = document.getElementById('configurator-cart-link');
let pendingCartAttempt = null;
let editingCartItem = null;
let pendingPropertyReconstruction = false;

// Le scelte complete NON viaggiano piu' come line item property: restano nel browser,
// indicizzate per requestId, e servono solo a riaprire una configurazione dal carrello.
const CONFIGURATION_CHOICES_STORAGE_KEY = '3dlab_configuration_choices_v1';
const CONFIGURATION_CHOICES_MAX_ENTRIES = 30;
const CONFIGURATION_CHOICES_TTL_MS = 30 * 24 * 60 * 60 * 1000;
const ATTRIBUTION_SYNC_TIMEOUT_MS = 3000;

function trackConfigurator(method, ...args) {
    try {
        window.ThreeDLabConfiguratorTracking?.[method]?.(...args);
    } catch (_) {
        // Il tracking non deve mai interferire con il configuratore.
    }
}

function readStoredConfigurations() {
    try {
        const parsed = JSON.parse(localStorage.getItem(CONFIGURATION_CHOICES_STORAGE_KEY) || '{}');
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (_) {
        return {};
    }
}

function storeConfigurationChoices(requestId) {
    if (!requestId) return;

    const now = Date.now();
    const entries = readStoredConfigurations();
    entries[requestId] = { choices: userChoices, storedAt: now };

    const pruned = {};
    Object.entries(entries)
        .filter(([, entry]) => entry && now - Number(entry.storedAt || 0) < CONFIGURATION_CHOICES_TTL_MS)
        .sort((a, b) => Number(b[1].storedAt) - Number(a[1].storedAt))
        .slice(0, CONFIGURATION_CHOICES_MAX_ENTRIES)
        .forEach(([key, entry]) => { pruned[key] = entry; });

    try {
        localStorage.setItem(CONFIGURATION_CHOICES_STORAGE_KEY, JSON.stringify(pruned));
    } catch (_) {
        // Storage pieno o bloccato: "Modifica" ripieghera' sulle properties leggibili.
    }
}

function loadStoredConfigurationChoices(requestId) {
    const choices = readStoredConfigurations()[requestId]?.choices;
    return choices && typeof choices === 'object' && !Array.isArray(choices) ? choices : null;
}

// Righe create dalla release precedente portano ancora _configuration_choices: restano leggibili.
function parseLegacyConfigurationChoices(serialized) {
    if (typeof serialized !== 'string' || !serialized) return null;
    try {
        const parsed = JSON.parse(serialized);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch (_) {
        return null;
    }
}

function applyRestoredChoices(choices) {
    userChoices = { ...userChoices, ...choices };
    const has = (key) => Object.prototype.hasOwnProperty.call(choices, key);
    if (has('logo_type')) hasAppliedDefaultLogo = true;
    if (has('logo2_type')) hasAppliedDefaultLogo2 = true;
    if (has('logo_color')) hasUserSelectedLogoColor = true;
    if (has('logo2_color')) hasUserSelectedLogo2Color = true;
}

function findOptionForReadableValue(step, value) {
    const text = String(value);
    return step.type === 'color'
        ? step.options.find((option) => option.name === text || option.orderName === text)
        : step.options.find((option) => option.label === text || option.orderLabel === text);
}

// Ultimo fallback di "Modifica": ricostruisce le scelte dalle properties leggibili della riga.
// Richiede gli step gia' generati; se cambia la base rigenera gli step e riprova.
function reconstructChoicesFromCartProperties(properties) {
    if (!properties) return;

    for (let pass = 0; pass < 2; pass += 1) {
        let baseChanged = false;

        configSteps.forEach((step) => {
            if (baseChanged) return;
            const value = properties[step.name] ?? properties[step.orderName];
            if (value === undefined || value === null || value === '') return;

            const option = findOptionForReadableValue(step, value);
            if (!option) return;

            const choice = step.type === 'color' ? option.hex : option.id;
            if (step.id === 'base_type' && userChoices.base_type !== choice) {
                userChoices.base_type = choice;
                baseChanged = true;
                return;
            }
            applyRestoredChoices({ [step.id]: choice });
        });

        if (!baseChanged) break;
        generateConfigSteps();
    }

    renderBottomUI();
    updateModel();
}

let attributionSync = Promise.resolve();

// Parte al click e gira in parallelo a preview e creazione prodotto: si attende solo subito
// prima di toccare il carrello, quindi di norma non aggiunge nessuna attesa.
function startAttributionSync() {
    try {
        attributionSync = Promise.resolve(window.ThreeDLabAttribution?.syncToCart?.()).catch(() => {});
    } catch (_) {
        attributionSync = Promise.resolve();
    }
}

function awaitAttributionSync() {
    return Promise.race([attributionSync, waitFor(ATTRIBUTION_SYNC_TIMEOUT_MS)]);
}

if (configuratorCartLink) configuratorCartLink.textContent = configuratorText('goToCart');
if (configuratorCartSuccessDismiss) configuratorCartSuccessDismiss.textContent = configuratorText('continueConfiguring');
if (configuratorCartSuccessMessage) configuratorCartSuccessMessage.textContent = configuratorText('cartSuccess');

function readPreviewAsDataUrl(previewBlob) {
    if (!previewBlob) return Promise.resolve('');

    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => resolve(
            typeof reader.result === 'string' ? reader.result : ''
        ), { once: true });
        reader.addEventListener('error', () => resolve(''), { once: true });
        reader.readAsDataURL(previewBlob);
    });
}

async function openCartDrawerAfterRedirect(customProduct, requestId, previewBlob) {
    const fallbackCartUrl = SHOPIFY.cartUrl || '/cart';
    const customProductHandle = String(customProduct?.handle || '').trim();

    if (!customProductHandle) {
        window.location.assign(fallbackCartUrl);
        return;
    }

    const rootUrl = String(SHOPIFY.rootUrl || '/');
    const normalizedRootUrl = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
    const productUrl = `${normalizedRootUrl}products/${encodeURIComponent(customProductHandle)}`;

    try {
        const previewDataUrl = await readPreviewAsDataUrl(previewBlob);
        const redirectState = {
            requestId: String(requestId || ''),
            customProductId: String(customProduct.productId || ''),
            previewDataUrl
        };

        let redirectStateStored = false;
        try {
            sessionStorage.setItem(
                CART_DRAWER_REDIRECT_FLAG,
                JSON.stringify(redirectState)
            );
            redirectStateStored = true;
        } catch (_) {
            // Se lo storage e pieno, conserva almeno il comando one-shot di apertura.
            try {
                sessionStorage.setItem(CART_DRAWER_REDIRECT_FLAG, '1');
                redirectStateStored = true;
            } catch (_) {
                // Il parametro temporaneo nella URL mantiene il fallback senza storage.
            }
        }

        const destinationUrl = new URL(productUrl, window.location.origin);
        if (customProduct.variantId) {
            destinationUrl.searchParams.set('variant', String(customProduct.variantId));
        }
        if (!redirectStateStored) {
            destinationUrl.searchParams.set(CART_DRAWER_REDIRECT_QUERY_PARAM, '1');
        }
        window.location.assign(destinationUrl.toString());
    } catch (_) {
        window.location.assign(fallbackCartUrl);
    }
}

function setAddToCartButtons({ disabled, text, added = false }) {
    document.querySelectorAll(ADD_TO_CART_BUTTON_SELECTOR).forEach((button) => {
        button.disabled = disabled;
        button.innerText = text;
        button.classList.toggle('is-added', added);
    });
}

function hideConfiguratorCartSuccess() {
    if (configuratorCartSuccess) configuratorCartSuccess.hidden = true;
}

function showConfiguratorCartSuccess(
  message = configuratorText('cartSuccess')
) {
    setConfiguratorLoadingState(false);
    if (configuratorCartLink) configuratorCartLink.href = SHOPIFY.cartUrl || '/cart';
    if (configuratorCartSuccessMessage) configuratorCartSuccessMessage.textContent = message;
    if (configuratorCartSuccessDismiss) configuratorCartSuccessDismiss.hidden = false;
    if (configuratorCartSuccess) configuratorCartSuccess.hidden = false;
}

function showConfiguratorCartVerification() {
    setConfiguratorLoadingState(false);
    if (configuratorCartLink) configuratorCartLink.href = SHOPIFY.cartUrl || '/cart';
    if (configuratorCartSuccessMessage) {
        configuratorCartSuccessMessage.textContent = configuratorText('cartVerifyMessage');
    }
    if (configuratorCartSuccessDismiss) configuratorCartSuccessDismiss.hidden = true;
    if (configuratorCartSuccess) configuratorCartSuccess.hidden = false;
}

configuratorCartSuccessDismiss?.addEventListener('click', () => {
    hideConfiguratorCartSuccess();
    setAddToCartButtons({
        disabled: false,
        text: editingCartItem
            ? configuratorText('updateCustomization')
            : configuratorText('addToCart')
    });
});

function createRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
    }

    return `cfg-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

function getConfigurationSnapshot() {
    const choices = {};
    Object.keys(userChoices).sort().forEach((key) => {
        choices[key] = userChoices[key] ?? null;
    });

    return JSON.stringify({
        productId: String(SHOPIFY.productId),
        variantId: String(SHOPIFY.variantId),
        choices
    });
}

async function createConfigurationHash(snapshot) {
    if (window.crypto?.subtle && typeof TextEncoder !== 'undefined') {
        try {
            const bytes = new TextEncoder().encode(snapshot);
            const digest = await window.crypto.subtle.digest('SHA-256', bytes);
            return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
        } catch (_) {
            // Alcune WebView espongono SubtleCrypto ma ne bloccano l'uso: usa il fallback locale.
        }
    }

    // FNV-1a e solo un identificatore diagnostico per i browser meno recenti.
    let hash = 0x811c9dc5;
    for (let index = 0; index < snapshot.length; index += 1) {
        hash ^= snapshot.charCodeAt(index);
        hash = Math.imul(hash, 0x01000193);
    }
    return `fnv1a-${(hash >>> 0).toString(16).padStart(8, '0')}`;
}

function getCartAttempt(configHash) {
    if (!pendingCartAttempt || pendingCartAttempt.configHash !== configHash) {
        pendingCartAttempt = {
            configHash,
            requestId: createRequestId(),
            previewBlob: null,
            customProduct: null
        };
    }

    return pendingCartAttempt;
}

function getPreviewFilename(previewBlob) {
    if (previewBlob.type === 'image/png') return 'preview.png';
    if (previewBlob.type === 'image/jpeg') return 'preview.jpg';
    return 'preview.webp';
}

const CART_ADD_RETRY_DELAY_MS = 1000;
const CART_ADD_MAX_ATTEMPTS = 12;
const CART_VERIFICATION_DELAYS = [250, 750];

function waitFor(milliseconds) {
    return new Promise((resolve) => window.setTimeout(resolve, milliseconds));
}

function getCartJsonUrl() {
    const cartUrl = (window.routes && window.routes.cart_url) || SHOPIFY.cartUrl || '/cart';
    const normalizedUrl = cartUrl.replace(/\/$/, '');
    return normalizedUrl.endsWith('.js') ? normalizedUrl : `${normalizedUrl}.js`;
}

function getCartChangeUrl() {
    const url = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    return url.endsWith('.js') ? url : `${url}.js`;
}

function getCartAddUrl() {
    const url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    return url.endsWith('.js') ? url : `${url}.js`;
}

async function fetchCart() {
    const response = await fetch(getCartJsonUrl(), {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
    });
    if (!response.ok) throw new Error(configuratorText('cartReadError'));

    return response.json();
}

function findConfigurationCartItem(
  cart,
  { requestId, baseVariantId = '', customProductId = '' }
) {
    if (!Array.isArray(cart.items)) return null;

    return cart.items.find((cartItem) => {
        const properties = cartItem.properties || {};
        if (String(properties._configuration_request_id || '') !== String(requestId)) return false;
        if (baseVariantId && String(properties._base_variant_id || '') !== String(baseVariantId)) return false;
        if (customProductId && String(properties._custom_product_id || '') !== String(customProductId)) return false;
        return true;
    }) || null;
}

async function restoreEditingConfiguration() {
    const configurationId = new URL(window.location.href)
        .searchParams
        .get('configuration');
    if (!configurationId) return;

    try {
        const cart = await fetchCart();
        const item = findConfigurationCartItem(cart, {
            requestId: configurationId,
            baseVariantId: SHOPIFY.variantId
        });
        if (!item) return;

        const customProductId = String(item.properties?._custom_product_id || '');
        if (!customProductId || !item.key) return;

        const restoredChoices = loadStoredConfigurationChoices(configurationId)
            || parseLegacyConfigurationChoices(item.properties?._configuration_choices);
        if (restoredChoices) {
            applyRestoredChoices(restoredChoices);
        } else {
            // Storage svuotato o altro dispositivo: dopo la generazione degli step si
            // ricostruiscono le scelte dalle properties leggibili della riga.
            pendingPropertyReconstruction = true;
        }

        editingCartItem = {
            key: item.key,
            quantity: item.quantity,
            properties: item.properties || {},
            customProductId,
            customVariantId: String(item.properties?._custom_variant_id || item.variant_id || ''),
            customHandle: String(item.properties?._custom_product_handle || ''),
            requestId: configurationId
        };
        setAddToCartButtons({
            disabled: false,
            text: configuratorText('updateCustomization')
        });
    } catch (error) {
        console.warn('Impossibile ripristinare la configurazione dal carrello.', error);
    }
}

function buildCartProperties(
  readableChoices,
  customProduct,
  requestId,
  configHash
) {
    const properties = { 'Design personalizzato': 'Si' };
    Object.entries(readableChoices).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        properties[key] = value;
    });

    properties._base_product_handle = String(SHOPIFY.productHandle || '');
    properties._base_product_id = String(SHOPIFY.productId);
    properties._base_variant_id = String(SHOPIFY.variantId);
    if (SHOPIFY.variantTitle) properties._base_variant_title = String(SHOPIFY.variantTitle);
    if (SHOPIFY.variantSku) properties._base_variant_sku = String(SHOPIFY.variantSku);
    if (customProduct.productId) properties._custom_product_id = String(customProduct.productId);
    if (customProduct.handle) properties._custom_product_handle = String(customProduct.handle);
    properties._custom_variant_id = String(customProduct.variantId);
    properties._configuration_request_id = requestId;
    properties._configuration_hash = configHash;

    return properties;
}

async function resolveCurrentEditingCartLine() {
    const cart = await fetchCart();
    const item = findConfigurationCartItem(cart, {
        requestId: editingCartItem.requestId,
        customProductId: editingCartItem.customProductId
    });
    if (!item?.key) {
        throw new Error(configuratorText('customProductMissingInCart'));
    }

    editingCartItem.key = String(item.key);
    editingCartItem.quantity = item.quantity;
    editingCartItem.properties = item.properties || {};
    return item;
}

async function updateEditingCartLine(properties) {
    let lastErrorBody = {};

    for (let attempt = 0; attempt < 2; attempt += 1) {
        const item = await resolveCurrentEditingCartLine();
        const cartResponse = await fetch(getCartChangeUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                id: String(item.key),
                quantity: item.quantity,
                properties
            })
        });
        const cartBody = await cartResponse.json().catch(() => ({}));
        if (cartResponse.ok) {
            const updatedItem = findConfigurationCartItem(cartBody, {
                requestId: editingCartItem.requestId,
                customProductId: editingCartItem.customProductId
            });
            if (updatedItem?.key) {
                editingCartItem.key = String(updatedItem.key);
                editingCartItem.quantity = updatedItem.quantity;
            }
            editingCartItem.properties = properties;
            return;
        }

        lastErrorBody = cartBody;
        if (cartResponse.status !== 400) break;
    }

    throw new Error(
        lastErrorBody.description
        || lastErrorBody.message
        || configuratorText('cartUpdateError')
    );
}

async function updateExistingConfiguration(configHash, readableChoices) {
    setConfiguratorLoadingState(true, configuratorText('generatingPreview'));
    const previewBlob = await captureTopScreenshotBlob();
    if (!previewBlob || previewBlob.size === 0) {
        throw new Error(configuratorText('previewError'));
    }

    const updateUrl = `${CUSTOM_PRODUCT_API_BASE}/api/custom-products/${encodeURIComponent(editingCartItem.customProductId)}/preview`;
    const formData = new FormData();
    formData.append('preview', previewBlob, getPreviewFilename(previewBlob));

    setConfiguratorLoadingState(true, configuratorText('updatingCustomProduct'));
    const updateResponse = await fetch(updateUrl, {
        method: 'PATCH',
        headers: { 'Accept': 'application/json' },
        body: formData
    });
    const updateBody = await updateResponse.json().catch(() => ({}));
    if (!updateResponse.ok) {
        throw new Error(
            updateBody.error
            || updateBody.detail
            || updateBody.title
            || updateBody.message
            || configuratorText('customProductUpdateError')
        );
    }

    const customProduct = {
        productId: updateBody.productId ?? updateBody.ProductId ?? editingCartItem.customProductId,
        variantId: updateBody.variantId ?? updateBody.VariantId ?? editingCartItem.customVariantId,
        handle: updateBody.handle ?? updateBody.Handle ?? editingCartItem.customHandle
    };
    const properties = buildCartProperties(
        readableChoices,
        customProduct,
        editingCartItem.requestId,
        configHash
    );

    setConfiguratorLoadingState(true, configuratorText('updatingCart'));
    storeConfigurationChoices(editingCartItem.requestId);
    await awaitAttributionSync();
    await updateEditingCartLine(properties);

    return {
        customProduct,
        requestId: editingCartItem.requestId,
        previewBlob
    };
}

async function cartContainsConfiguration(requestId) {
    const cart = await fetchCart();
    return Array.isArray(cart.items) && cart.items.some((item) => (
        String(item.properties?._configuration_request_id || '') === requestId
    ));
}

async function verifyAmbiguousCartAdd(requestId) {
    let allChecksSucceeded = true;

    for (const delay of CART_VERIFICATION_DELAYS) {
        await waitFor(delay);
        try {
            if (await cartContainsConfiguration(requestId)) return true;
        } catch (_) {
            allChecksSucceeded = false;
        }
    }

    return allChecksSucceeded ? false : null;
}

async function addCartWithRetry(cartData, requestId) {
    let attempt = 1;

    while (true) {
        let response;
        try {
            response = await fetch(getCartAddUrl(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(cartData)
            });
        } catch (_) {
            const verificationResult = await verifyAmbiguousCartAdd(requestId);
            if (verificationResult === true) return { verifiedFromCart: true };
            if (verificationResult === null) {
                const ambiguousError = new Error(configuratorText('cartOutcomeAmbiguous'));
                ambiguousError.cartOutcomeAmbiguous = true;
                throw ambiguousError;
            }
            throw new Error(configuratorText('cartConnectionInterrupted'));
        }

        const body = await response.json().catch(() => ({}));
        if (response.ok) return body;

        const isPropagationError = response.status === 404 || response.status === 422;
        if (!isPropagationError || attempt >= CART_ADD_MAX_ATTEMPTS) {
            const detail = body.description || body.message || body.error;
            throw new Error(
                detail
                ? configuratorText('cartStatusDetail').replace('{status}', response.status).replace('{detail}', detail)
                : configuratorText('cartStatus').replace('{status}', response.status)
            );
        }

        setConfiguratorLoadingState(
            true,
            configuratorText('syncingShopify').replace('{attempt}', attempt).replace('{max}', CART_ADD_MAX_ATTEMPTS)
        );
        await waitFor(CART_ADD_RETRY_DELAY_MS);
        attempt += 1;
    }
}

// Aggiungi al carrello con screenshot top-view
window.addToCart = async () => {
    const cartLabels = getCartLabels();
    if (!SHOPIFY.productId || !SHOPIFY.variantId) {
        alert(configuratorText('productVariantMissing'));
        return;
    }
    if (isAddingToCart) return;
    isAddingToCart = true;
    hideConfiguratorCartSuccess();
    setConfiguratorLoadingState(true, cartLabels.adding);
    setAddToCartButtons({
        disabled: true,
        text: editingCartItem
            ? configuratorText('updatingInProgress')
            : cartLabels.adding
    });

    const readableChoices = getReadableChoices();
    trackConfigurator('complete');

    try {
        startAttributionSync();

        const configHash = await createConfigurationHash(getConfigurationSnapshot());

        if (editingCartItem) {
            const updatedConfiguration = await updateExistingConfiguration(
                configHash,
                readableChoices
            );
            pendingCartAttempt = null;
            isAddingToCart = false;
            setAddToCartButtons({
                disabled: false,
                text: configuratorText('updatedDone'),
                added: true
            });
            await openCartDrawerAfterRedirect(
                updatedConfiguration.customProduct,
                updatedConfiguration.requestId,
                updatedConfiguration.previewBlob
            );
            return;
        }

        const cartAttempt = getCartAttempt(configHash);
        let customProduct = cartAttempt.customProduct;

        // Se il prodotto era gia stato creato ma cart/add era fallito, riusalo senza duplicarlo.
        if (!customProduct) {
            let previewBlob = cartAttempt.previewBlob;
            if (!previewBlob) {
                setConfiguratorLoadingState(true, configuratorText('generatingPreview'));
                previewBlob = await captureTopScreenshotBlob();
                if (!previewBlob || previewBlob.size === 0) {
                    throw new Error(cartLabels.previewError);
                }
                cartAttempt.previewBlob = previewBlob;
            }

            const customProductUrl = `${CUSTOM_PRODUCT_API_BASE}/api/products/${encodeURIComponent(String(SHOPIFY.productId))}/variants/${encodeURIComponent(String(SHOPIFY.variantId))}/custom`;
            const formData = new FormData();
            formData.append('preview', previewBlob, getPreviewFilename(previewBlob));
            formData.append('requestId', cartAttempt.requestId);
            formData.append('configHash', cartAttempt.configHash);

            setConfiguratorLoadingState(true, configuratorText('creatingCustomProduct'));
            const response = await fetch(customProductUrl, {
                method: 'POST',
                headers: { 'Accept': 'application/json' },
                body: formData
            });

            const body = await response.json().catch(() => ({}));
            if (!response.ok) {
                throw new Error(body.error || body.detail || body.title || body.message || configuratorText('customProductCreateError'));
            }

            customProduct = {
                productId: body.productId ?? body.ProductId,
                variantId: body.variantId ?? body.VariantId,
                handle: body.handle ?? body.Handle
            };

            if (!customProduct.variantId) {
                throw new Error(configuratorText('missingCustomVariant'));
            }

            cartAttempt.customProduct = customProduct;
        }

        const properties = buildCartProperties(
            readableChoices,
            customProduct,
            cartAttempt.requestId,
            cartAttempt.configHash
        );

        const cartData = {
            items: [{
                id: String(customProduct.variantId),
                quantity: 1,
                properties
            }]
        };

        setConfiguratorLoadingState(true, cartLabels.adding);
        storeConfigurationChoices(cartAttempt.requestId);
        await awaitAttributionSync();
        await addCartWithRetry(cartData, cartAttempt.requestId);
        trackConfigurator('addedToCart', cartAttempt.requestId);

        const redirectRequestId = cartAttempt.requestId;
        const redirectPreviewBlob = cartAttempt.previewBlob;
        pendingCartAttempt = null;
        isAddingToCart = false;
        await openCartDrawerAfterRedirect(
            customProduct,
            redirectRequestId,
            redirectPreviewBlob
        );
        return;
    } catch (error) {
        isAddingToCart = false;
        if (error.cartOutcomeAmbiguous) {
            setAddToCartButtons({ disabled: true, text: configuratorText('verifyCart') });
            showConfiguratorCartVerification();
            return;
        }

        alert(`${cartLabels.addError}: ${error.message}`);
        setConfiguratorLoadingState(false);
        setAddToCartButtons({
            disabled: false,
            text: editingCartItem
                ? configuratorText('updateCustomization')
                : cartLabels.add
        });
    }
};

window.finishConfiguration = () => {
    const readableChoices = getReadableChoices();
    
    const summary = Object.entries(readableChoices)
        .map(([key, value]) => `${key}: ${value}`)
        .join('\n');
    
    const message = `${configuratorText('configurationComplete')}\n\n${summary}`;
    
    alert(message);
};

// Funzione per ottenere i nomi leggibili dalle scelte
function getReadableChoices() {
    const result = {};
    
    configSteps.forEach((step) => {
        const choice = userChoices[step.id];
        let readableName = '';
        
        if (step.type === 'color') {
            // Cerca il nome del colore
            const colorOption = step.options.find(opt => opt.hex === choice);
            readableName = colorOption ? colorOption.name : choice.toString(16);
        } else if (step.type === 'pill') {
            // Cerca il label del logo
            const pillOption = step.options.find(opt => opt.id === choice);
            readableName = pillOption ? pillOption.label : choice;
        }
        
        result[step.name] = readableName;
    });
    
    return result;
};

// Le properties leggibili dell'ordine restano in italiano, indipendentemente dalla lingua dell'interfaccia.
function getItalianOrderChoices() {
    const result = {};

    configSteps.forEach((step) => {
        const choice = userChoices[step.id];
        let readableName = '';

        if (step.type === 'color') {
            const colorOption = step.options.find(opt => opt.hex === choice);
            readableName = colorOption ? colorOption.orderName : choice.toString(16);
        } else if (step.type === 'pill') {
            const pillOption = step.options.find(opt => opt.id === choice);
            readableName = pillOption ? (pillOption.orderLabel || pillOption.label) : choice;
        }

        result[step.orderName] = readableName;
    });

    return result;
}

// Inizializza UI quando il modello è caricato
// (il vero init avverrà in loader.load() quando generateConfigSteps() viene chiamato)
//ULTIMA VERSIONE
